function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { Field, Form as FormikForm, Formik } from "formik";
import Form from "react-bootstrap/Form";
import moment from "moment";
import classNames from "classnames";
import "./TimesheetSettings.css";
import { UserContext, FilterContext } from "../index";
import { useQuery, useMutation } from "@apollo/client";
import { WORK_DAY_SETTINGS_QUERY, ADD_WORK_DAY_SETTINGS_MUTATION, WEB_ORGANISATION_SETTINGS_QUERY } from "./query";
import { findDemoOrLiveSite } from "../SideMenu/Header";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Select from "react-select";
import { WorkingDaysList, expectedWorkingHourData, productiveWorkingHourData, ScreenshotList, IdelTimeList, timezoneList, IdleMinutesList, IdelTimeThresholdList, ScreenshotListFreePlan, currenciesList, payrollCurrenciesList, PayrollCycleList, WeekStartDaysList } from "./data";
import { toast } from "react-toastify";
import { isRateLimited, rateLimitMessage } from "../utils";
import ReactTooltip from "react-tooltip";
import { HiQuestionMarkCircle } from "react-icons/hi";
import TimePicker from "rc-time-picker";
import { Alert, Modal } from "react-bootstrap";
import { FaInfoCircle, FaCamera, FaClock, FaDesktop, FaBell, FaExclamationTriangle, FaRegCalendarAlt, FaRegCalendarCheck, FaRegCalendar, FaRegCalendarTimes } from "react-icons/fa"; // FontAwesome Icons

/*  Maps the icon name stored in PayrollCycleList to its icon component */
var PayrollCycleIcons = {
  FaRegCalendarAlt: FaRegCalendarAlt,
  FaRegCalendarCheck: FaRegCalendarCheck,
  FaRegCalendar: FaRegCalendar,
  FaRegCalendarTimes: FaRegCalendarTimes
};

/*  Track setting page initial component */
var TimesheetSettings = function TimesheetSettings(props) {
  var _workDayData$workDayS;
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    teamId = _React$useContext2.teamId,
    organisationId = _React$useContext2.organisationId,
    role = _React$useContext2.role,
    organisationBilling = _React$useContext2.organisationBilling,
    from = _React$useContext2.from,
    organisationSettings = _React$useContext2.organisationSettings,
    organisationStatus = _React$useContext2.organisationStatus;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    preminumPlanSetting = _React$useState2[0],
    setPreminumPlanSetting = _React$useState2[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" || organisationId == "f2c9e240-4e71-11eb-9784-794f853f90e2" || organisationId == "22cb3fb0-a27a-11ef-992a-a3d490cf2e0d" || organisationId == "5da90b00-1205-11ee-99eb-6f59a4034ddc" || organisationId == "35fcc020-e2ec-11ee-9c92-a7c3dd681c18" || organisationId == "0b05daf0-1a59-11f0-ab0d-8dc7aeb69888" || organisationId == "3c1ddfd0-21b6-11ef-8be8-25513e762037" || organisationId == "b8a0b6a0-389b-11ed-9b14-ebb2f09d4883" || organisationId == "37b19790-9206-11f0-acfe-091be3718816" //anitha test account
    ) {
      setPreminumPlanSetting(true);
    }
  }, [organisationId, organisationBilling]);
  var loadPage = role === "Admin" || role === null;
  var Redirect = props.redirect;

  /* onload data query */
  var _useQuery = useQuery(WORK_DAY_SETTINGS_QUERY, {
      variables: {
        organisationId: organisationId
      }
    }),
    workDayData = _useQuery.data,
    workDayError = _useQuery.error,
    workDayLoading = _useQuery.loading,
    refetch = _useQuery.refetch;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key]);
  if (!loadPage) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  if (workDayLoading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (workDayError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!workDayData) {
    return null;
  }
  var workDaySettings = (_workDayData$workDayS = workDayData.workDaySettings) === null || _workDayData$workDayS === void 0 ? void 0 : _workDayData$workDayS.workSettings;
  if (!workDaySettings) {
    return null;
  }
  var orgSettings = workDayData.workDaySettings.pageComponent;
  var planConfig = workDayData.workDaySettings.planConfig;
  var showStealthMode = workDayData.workDaySettings.showStealthMode;
  // console.log("organisationBilling", organisationBilling);

  /* TimesheetForm function */
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TimesheetForm, {
    workDaySettings: workDaySettings,
    teamId: teamId,
    organisationId: organisationId,
    orgSettings: orgSettings,
    planConfig: planConfig,
    planId: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId,
    showStealthMode: showStealthMode,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings,
    preminumPlanSetting: preminumPlanSetting
  }));
};
var formats = "h:mm a";

/*  TimesheetForm data process */
var TimesheetForm = function TimesheetForm(props) {
  var _workDaySettings$scre, _workDaySettings$blur, _workDaySettings$scre2, _workDaySettings$gene, _workDaySettings$work, _workDaySettings$prod, _workDaySettings$orga, _workDaySettings$idle2, _workDaySettings$idle3, _workDaySettings$idle4, _workDaySettings$proj, _workDaySettings$manu, _workDaySettings$admi, _workDaySettings$addP, _workDaySettings$addT, _workDaySettings$offl, _workDaySettings$allo, _workDaySettings$allo2, _workDaySettings$allo3, _workDaySettings$allo4, _workDaySettings$allo5, _workDaySettings$stea, _workDaySettings$repo, _workDaySettings$sche, _workDaySettings$trac, _workDaySettings$trac2, _workDaySettings$allo6, _workDaySettings$allo7, _workDaySettings$orga2, _workDaySettings$hide, _workDaySettings$hide2, _workDaySettings$auto, _workDaySettings$allo8, _workDaySettings$allo9, _workDaySettings$auto2, _workDaySettings$rest, _workDaySettings$holi, _workDaySettings$enab, _workDaySettings$manu2, _workDaySettings$enab2, _workDaySettings$payr, _workDaySettings$payr2, _workDaySettings$payr3, _workDaySettings$keyS, _workDaySettings$mous, _workDaySettings$allo10, _workDaySettings$enab3, _workDaySettings$enab4, _workDaySettings$expe, _workDaySettings$idle5, _workDaySettings$hide3, _workDaySettings$allo11, _workDaySettings$allo12, _workDaySettings$allo13, _workDaySettings$allo14, _workDaySettings$enab5;
  var workDaySettings = props.workDaySettings,
    teamId = props.teamId,
    organisationId = props.organisationId,
    orgSettings = props.orgSettings,
    planConfig = props.planConfig,
    planId = props.planId,
    showStealthMode = props.showStealthMode,
    organisationBilling = props.organisationBilling,
    organisationSettings = props.organisationSettings,
    preminumPlanSetting = props.preminumPlanSetting;
  var isDemoOrLiveSite = findDemoOrLiveSite();
  var _React$useState3 = React.useState(["Monday"]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    activeWorkingDays = _React$useState4[0],
    setWorkingDays = _React$useState4[1];
  var _React$useState5 = React.useState(moment()),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    startTime = _React$useState6[0],
    setStartTime = _React$useState6[1];
  var _React$useState7 = React.useState(moment()),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    endTime = _React$useState8[0],
    setEndTime = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    addWorkDayStatus = _React$useState10[0],
    setAddWorkDayStatus = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    showSettingsUpdateModal = _React$useState12[0],
    setShowSettingsUpdateModal = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    showUserSettingsUpdateModal = _React$useState14[0],
    setUserShowSettingsUpdateModal = _React$useState14[1];
  var _React$useState15 = React.useState(null),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    pendingFormValues = _React$useState16[0],
    setPendingFormValues = _React$useState16[1];
  var _React$useState17 = React.useState(workDaySettings.idleAlertMinutes > 0 ? true : false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isToggledIdleAlert = _React$useState18[0],
    setIsToggledIdleAlert = _React$useState18[1];
  var _React$useState19 = React.useState(Number(workDaySettings.idleTimeStrictnessLevel) > 0 ? true : false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    minimumActivityEnabled = _React$useState20[0],
    setMinimumActivityEnabled = _React$useState20[1];
  var _React$useState21 = React.useState(workDaySettings.trackingEndTime ? moment(workDaySettings.trackingEndTime) : undefined),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    modalValueEndTime = _React$useState22[0],
    setModalValueEndTime = _React$useState22[1];
  var _React$useState23 = React.useState(workDaySettings.trackingStartTime ? moment(workDaySettings.trackingStartTime) : undefined),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    modalValueStartTime = _React$useState24[0],
    setModalValueStartTime = _React$useState24[1];
  // const [modalValueStartTime, setModalValueStartTime] = React.useState(undefined);
  // const [modalStartTime, setModalStartTime] = React.useState("");
  // const [startTimeTemp, setStartTimeTemp] = React.useState(null);

  var _React$useState25 = React.useState(workDaySettings.alertStartTime ? moment(workDaySettings.alertStartTime) : moment().hour(9).minute(0)),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    alertStartTime = _React$useState26[0],
    setAlertStartTime = _React$useState26[1];
  var _React$useState27 = React.useState(workDaySettings.alertEndTime ? moment(workDaySettings.alertEndTime) : moment().hour(18).minute(0)),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    alertEndTime = _React$useState28[0],
    setAlertEndTime = _React$useState28[1];
  var formats = "h:mm a";
  var selectWorkingDays = function selectWorkingDays(workingDays) {
    setWorkingDays(function (prev) {
      return prev.includes(workingDays) ? prev.filter(function (a) {
        return a !== workingDays;
      }) : [].concat(_toConsumableArray(prev), [workingDays]);
    });
  };
  var handleStartTimeChange = function handleStartTimeChange(value) {
    setStartTime(value);
  };
  var handleEndTimeChange = function handleEndTimeChange(value) {
    setEndTime(value);
  };
  var expectedClockInOnChange = function expectedClockInOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setFieldValue("expectedClockInTime", value);
    } else {
      setFieldValue("expectedClockInTime", null);
    }
  };

  /** ADD WORK DAY SETTINGS FUNCTIONALITY **/
  var _useMutation = useMutation(ADD_WORK_DAY_SETTINGS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addWorkDaySettings = _useMutation2[0],
    addWorkDaySettingsLoading = _useMutation2[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, applyTo) {
      var _localStorage2, _localStorage2$getIte, _localStorage3, _localStorage3$getIte;
      var _localStorage, _localStorage$setItem, variables, response, serverMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(modalValueEndTime < modalValueStartTime)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (organisationId == "629823d0-ea16-11eb-8ecf-fd402ded7fa3") {
              if (!values.enablePersonWiseTimezone) {
                localStorage.removeItem("timezone");
              } else {
                (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : (_localStorage$setItem = _localStorage.setItem) === null || _localStorage$setItem === void 0 ? void 0 : _localStorage$setItem.call(_localStorage, "timezone", "userTimezone");
              }
            }
            setShowSettingsUpdateModal(((_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : (_localStorage2$getIte = _localStorage2.getItem) === null || _localStorage2$getIte === void 0 ? void 0 : _localStorage2$getIte.call(_localStorage2, "showSettingsUpdatedWarningAgain")) == "true" ? false : ((_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : (_localStorage3$getIte = _localStorage3.getItem) === null || _localStorage3$getIte === void 0 ? void 0 : _localStorage3$getIte.call(_localStorage3, "showSettingsUpdatedWarningAgain")) == "false" ? true : true);
            variables = {
              workingDays: workDaySettings.workingDays === values.workingDays.join() ? null : values.workingDays.join(),
              screenCapture: workDaySettings.screenCapture === values.screenCapture ? null : values.screenCapture.toString(),
              blurScreenCapture: workDaySettings.blurScreenCapture === values.blurScreenCapture ? null : values.blurScreenCapture.toString(),
              screenCaptureInterval: workDaySettings.screenCaptureInterval === values.screenCaptureInterval ? null : values.screenCaptureInterval,
              generateTimelapseVideo: workDaySettings.generateTimelapseVideo === values.generateTimelapseVideo ? null : values.generateTimelapseVideo.toString(),
              idleAlertMinutes: Number(workDaySettings.idleAlertMinutes) <= 0 && workDaySettings.idleAlertMinutes === values.idleAlertMinutes ? null : values.idleAlertMinutes,
              idleAlertOverride: workDaySettings.idleAlertOverride === values.idleAlertOverride ? null : values.idleAlertOverride.toString(),
              idleMinutesThreshold: workDaySettings.idleMinutesThreshold === values.idleMinutesThreshold ? null : values.idleMinutesThreshold,
              workingHoursPerDay: workDaySettings.workingHoursPerDay === values.workingHoursPerDay ? null : values.workingHoursPerDay,
              productiveHours: workDaySettings.productiveHours === values.productiveHours ? null : values.productiveHours,
              organisationTimezone: workDaySettings.organisationTimezone === values.organisationTimezone ? null : values.organisationTimezone,
              //idleTime: workDaySettings.idleTime === values.idleTime ? null : values.idleTime,

              // trackAppsAndWebsites:
              //   workDaySettings.trackAppsAndWebsites === values.trackAppsAndWebsites
              //     ? null
              //     : values.trackAppsAndWebsites.toString(),

              idleTimeForRiskFactor: workDaySettings.idleTimeForRiskFactor === values.idleTimeForRiskFactor ? null : values.idleTimeForRiskFactor,
              workedHoursForRiskFactor: workDaySettings.workedHoursForRiskFactor === values.workedHoursForRiskFactor ? null : values.workedHoursForRiskFactor,
              unProductiveHoursForRiskFactor: workDaySettings.unProductiveHoursForRiskFactor === values.unProductiveHoursForRiskFactor ? null : values.unProductiveHoursForRiskFactor,
              projectManagementFeature: workDaySettings.projectManagementFeature === values.projectManagementFeature ? null : values.projectManagementFeature.toString(),
              manualTimeFeature: workDaySettings.manualTimeFeature === values.manualTimeFeature ? null : values.manualTimeFeature.toString(),
              adminCheck: workDaySettings.adminCheck === values.adminCheck ? null : values.adminCheck.toString(),
              addProjectDetails: workDaySettings.addProjectDetails === values.addProjectDetails ? null : values.addProjectDetails,
              allowAdminAndHeadsToAddAProject: workDaySettings.allowAdminAndHeadsToAddAProject === values.allowAdminAndHeadsToAddAProject ? null : values.allowAdminAndHeadsToAddAProject.toString(),
              allowEveryoneToAddProject: workDaySettings.addProjectDetails === values.addProjectDetails ? null : values.addProjectDetails === "allowEveryoneToAddProject" ? "true" : "false",
              // : "false",

              addTaskDetails: workDaySettings.addTaskDetails === values.addTaskDetails ? null : values.addTaskDetails,
              allowAdminHeadToAddTaskInProject: workDaySettings.addTaskDetails === values.addTaskDetails ? null : values.addTaskDetails === "allowAdminHeadToAddTaskInProject" ? "true" : "false",
              allowEveryoneToAddTaskInProject: workDaySettings.addTaskDetails === values.addTaskDetails ? null : values.addTaskDetails === "allowEveryoneToAddTaskInProject" ? "true" : "false",
              offlineTask: workDaySettings.offlineTask === values.offlineTask ? null : values.offlineTask.toString(),
              allowMemberToAccessScreenCapture: workDaySettings.allowMemberToAccessScreenCapture === values.allowMemberToAccessScreenCapture ? null : values.allowMemberToAccessScreenCapture.toString(),
              allowMemberToDeleteScreenCapture: workDaySettings.allowMemberToDeleteScreenCapture === values.allowMemberToDeleteScreenCapture ? null : values.allowMemberToDeleteScreenCapture.toString(),
              allowHeadToDeleteTeamMemberScreenCapture: workDaySettings.allowHeadToDeleteTeamMemberScreenCapture === values.allowHeadToDeleteTeamMemberScreenCapture ? null : values.allowHeadToDeleteTeamMemberScreenCapture.toString(),
              allowMemberToAccessTimesheet: workDaySettings.allowMemberToAccessTimesheet === values.allowMemberToAccessTimesheet ? null : values.allowMemberToAccessTimesheet.toString(),
              allowMemberToAccessTimelapseVideo: workDaySettings.allowMemberToAccessTimelapseVideo === values.allowMemberToAccessTimelapseVideo ? null : values.allowMemberToAccessTimelapseVideo.toString(),
              //usbMonitoring: workDaySettings.usbMonitoring === values.usbMonitoring ? null : values.usbMonitoring.toString(),
              stealthMode: workDaySettings.stealthMode === values.stealthMode ? null : values.stealthMode.toString(),
              reportSettings: workDaySettings.reportSettings === values.reportSettings ? null : values.reportSettings.toString(),
              organisationCurrencie: workDaySettings.organisationCurrencie === values.organisationCurrencie ? null : values.organisationCurrencie,
              organisationId: organisationId,
              // scheduleStealthMode:
              //   workDaySettings.scheduleStealthMode === values.scheduleStealthMode
              //     ? null
              //     : values.scheduleStealthMode.toString(),
              // trackingStartTime: values.startTime ? values.startTime : workDaySettings.trackingStartTime ? " " : null,
              // trackingEndTime: values.endTime ? values.endTime : workDaySettings.trackingEndTime ? " " : null,
              // timezone: organisationSettings?.organisationTimezone,
              // scheduleStealthMode:
              //   workDaySettings.scheduleStealthMode === values.scheduleStealthMode
              //     ? null
              //     : values.scheduleStealthMode.toString(),
              // trackingStartTime: values.startTime ? values.startTime : workDaySettings.trackingStartTime ? " " : null,
              // trackingEndTime: values.endTime ? values.endTime : workDaySettings.trackingEndTime ? " " : null,
              timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              expectedClockInTime: values.expectedClockInTime == null ? "" : moment(workDaySettings.expectedClockInTime).format("h:mm a") === moment(values.expectedClockInTime).format("h:mm a") ? null : moment(values.expectedClockInTime).format("h:mm a"),
              // allowHeadsToReviewApps: null,
              allowHeadsToReviewApps: workDaySettings.allowHeadsToReviewApps === values.allowHeadsToReviewApps ? null : values.allowHeadsToReviewApps.toString(),
              allowTheEmployeeToAccessWebsite: workDaySettings.allowTheEmployeeToAccessWebsite === values.allowTheEmployeeToAccessWebsite ? null : values.allowTheEmployeeToAccessWebsite.toString(),
              hideTheAdminDataFromAllPages: workDaySettings.hideTheAdminDataFromAllPages === values.hideTheAdminDataFromAllPages ? null : values.hideTheAdminDataFromAllPages.toString(),
              hideTheTeamHeadDataFromAllPages: workDaySettings.hideTheTeamHeadDataFromAllPages === values.hideTheTeamHeadDataFromAllPages ? null : values.hideTheTeamHeadDataFromAllPages.toString(),
              // alertStartTime: values.alertStartTime
              //   ? moment(values.alertStartTime).format("h:mm a")
              //   : moment(workDaySettings.alertStartTime).format("h:mm a")
              //   ? " "
              //   : null,
              // alertEndTime: values.alertEndTime
              //   ? moment(values.alertEndTime).format("h:mm a")
              //   : moment(workDaySettings.alertEndTime).format("h:mm a")
              //   ? " "
              //   : null,

              autoClockIn: workDaySettings.autoClockIn === values.autoClockIn ? null : values.autoClockIn.toString(),
              leaveManagementFeature: workDaySettings.leaveManagementFeature === values.leaveManagementFeature ? null : values.leaveManagementFeature.toString(),
              excludeUntrackedHours: workDaySettings.excludeUntrackedHours === values.excludeUntrackedHours ? null : values.excludeUntrackedHours.toString(),
              allowEmployeesToManageTheirTasks: workDaySettings.allowEmployeesToManageTheirTasks === values.allowEmployeesToManageTheirTasks ? null : values.allowEmployeesToManageTheirTasks.toString(),
              allowEmployeesToMarkTheirTasksAsCompleted: workDaySettings.allowEmployeesToMarkTheirTasksAsCompleted === values.allowEmployeesToMarkTheirTasksAsCompleted ? null : values.allowEmployeesToMarkTheirTasksAsCompleted.toString(),
              automaticTaskTimer: workDaySettings.automaticTaskTimer === values.automaticTaskTimer ? null : values.automaticTaskTimer.toString(),
              restrictNewTaskWhenPending: workDaySettings.restrictNewTaskWhenPending === values.restrictNewTaskWhenPending ? null : values.restrictNewTaskWhenPending.toString(),
              allowEmployeesToEditTaskTimes: workDaySettings.allowEmployeesToEditTaskTimes === values.allowEmployeesToEditTaskTimes ? null : values.allowEmployeesToEditTaskTimes.toString(),
              holidayMailCheck: workDaySettings.holidayMailCheck === values.holidayMailCheck ? null : values.holidayMailCheck.toString(),
              enablePersonWiseTimezone: workDaySettings.enablePersonWiseTimezone === values.enablePersonWiseTimezone ? null : values.enablePersonWiseTimezone.toString(),
              manualTimeMailCheck: workDaySettings.manualTimeMailCheck === values.manualTimeMailCheck ? null : values.manualTimeMailCheck.toString(),
              enableSalaryCalculator: workDaySettings.enableSalaryCalculator === values.enableSalaryCalculator ? null : values.enableSalaryCalculator.toString(),
              payrollCurrency: workDaySettings.payrollCurrency === values.payrollCurrency ? null : values.payrollCurrency,
              payrollCycle: workDaySettings.payrollCycle === values.payrollCycle && workDaySettings.payrollWeekStartsOn === values.payrollWeekStartsOn ? null : values.payrollCycle,
              payrollWeekStartsOn: values.payrollCycle === "weekly" || values.payrollCycle === "bi-weekly" ? workDaySettings.payrollWeekStartsOn === values.payrollWeekStartsOn ? null : values.payrollWeekStartsOn : null,
              keyStrokeCounter: workDaySettings.keyStrokeCounter === values.keyStrokeCounter ? null : values.keyStrokeCounter.toString(),
              mouseTracker: workDaySettings.mouseTracker === values.mouseTracker ? null : values.mouseTracker.toString(),
              // mouseTrackerMovements: workDaySettings.mouseTrackerMovements === values.mouseTrackerMovements ? null : values.mouseTrackerMovements.toString(),
              allowEmailNotificationWhenTaskStatusChange: workDaySettings.allowEmailNotificationWhenTaskStatusChange === values.allowEmailNotificationWhenTaskStatusChange ? null : values.allowEmailNotificationWhenTaskStatusChange.toString(),
              enableApiAccess: workDaySettings.enableApiAccess === values.enableApiAccess ? null : values.enableApiAccess.toString(),
              enableRealTimeAlert: workDaySettings.enableRealTimeAlert === values.enableRealTimeAlert ? null : values.enableRealTimeAlert.toString(),
              expectedActiveTime: workDaySettings.expectedActiveTime === values.expectedActiveTime ? null : values.expectedActiveTime,
              planType: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
              // unchanged -> null; switched off -> "0"
              idleTimeStrictnessLevel: (Number(workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.idleTimeStrictnessLevel) > 0 ? String(workDaySettings.idleTimeStrictnessLevel) : null) === (values.idleTimeStrictnessLevel || null) ? null : values.idleTimeStrictnessLevel || null,
              idleAlertBreak: values.idleAlertBreak != null ? values.idleAlertBreak.toString() : null,
              hideEditTrackSettingsFromTeamHeads: workDaySettings.hideEditTrackSettingsFromTeamHeads === values.hideEditTrackSettingsFromTeamHeads ? null : values.hideEditTrackSettingsFromTeamHeads.toString(),
              settingsApplyTo: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? null : applyTo,
              // settingsApplyTo: null,

              // idleAlertBreak: null,

              // never saved (null) and still off is not a change, so don't create a "false" row
              enableProjectManagementDesktopUI: workDaySettings.enableProjectManagementDesktopUI == null && values.enableProjectManagementDesktopUI == false || workDaySettings.enableProjectManagementDesktopUI === values.enableProjectManagementDesktopUI ? null : values.enableProjectManagementDesktopUI.toString()
            };
            _context.prev = 5;
            _context.next = 8;
            return addWorkDaySettings({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: WEB_ORGANISATION_SETTINGS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }, {
                query: WORK_DAY_SETTINGS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 8:
            response = _context.sent;
            if (!(!response || !response.data || response.data.addWorkDaySettings == null)) {
              _context.next = 13;
              break;
            }
            throw new Error("error");
          case 13:
            setAddWorkDayStatus(true);
            toast.success("Setting updated successfully!");
            // handleClose();
          case 15:
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](5);
            // addWorkDaySettings is capped at 10 per minute, per user, by two layers:
            // checkTrackSettingsCount in the resolver, which throws a GraphQL error,
            // and the work-day-settings limiter in the middleware, which answers 429.
            //
            // Those arrive differently. A 429 is a *network* error to Apollo, so its
            // reason never reaches error.message - that reads "Response not
            // successful: Received status code 429", which no amount of string
            // matching on "requests per minute" will catch, and the save would fall
            // through to the generic toast as if nothing had gone wrong. isRateLimited
            // reads the status instead, and rateLimitMessage takes the limiter's own
            // text out of the 429 body so the window stays right if it is retuned.
            //
            // The resolver's error still comes through error.message; apostrophes are
            // normalised there because the server message uses a curly one.
            if (isRateLimited(_context.t0)) {
              toast.error(rateLimitMessage(_context.t0, "You’ve reached the limit of 10 requests per minute. Please try again in a minute."));
            } else {
              serverMessage = (_context.t0.message || "").replace(/\u2019/g, "'");
              if (serverMessage.includes("requests per minute")) {
                toast.error("You’ve reached the limit of 10 requests per minute. Please try again in a minute.");
              } else {
                toast.error("Error occurred, Please try again later!");
              }
            }
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 17]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [addWorkDaySettings, addWorkDaySettingsLoading, activeWorkingDays, startTime, endTime]);
  var timezoneOfOnChange = function timezoneOfOnChange(setFieldValue) {
    return function (selectedArray) {
      if (selectedArray) {
        setFieldValue("organisationTimezone", selectedArray.value);
      } else {
        setFieldValue("organisationTimezone", []);
      }
    };
  };
  var currencyOfOnChange = function currencyOfOnChange(setFieldValue) {
    return function (selectedArray) {
      if (selectedArray) {
        setFieldValue("organisationCurrencie", selectedArray.value);
      } else {
        setFieldValue("organisationCurrencie", []);
      }
    };
  };
  var handleShowUserSettings = function handleShowUserSettings(values) {
    var _workDaySettings$idle, _values$idleAlertMinu;
    if (!workDaySettings) return;
    var variables = {
      workingDays: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.workingDays) === values.workingDays.join() ? null : values.workingDays.join(),
      screenCapture: workDaySettings.screenCapture == null && values.screenCapture == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.screenCapture) === values.screenCapture ? null : values.screenCapture.toString(),
      blurScreenCapture: workDaySettings.blurScreenCapture == null && values.blurScreenCapture == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.blurScreenCapture) === values.blurScreenCapture ? null : values.blurScreenCapture.toString(),
      screenCaptureInterval: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.screenCaptureInterval) === values.screenCaptureInterval ? null : values.screenCaptureInterval,
      generateTimelapseVideo: workDaySettings.generateTimelapseVideo == null && values.generateTimelapseVideo == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.generateTimelapseVideo) === values.generateTimelapseVideo ? null : values.generateTimelapseVideo.toString(),
      idleAlertMinutes:
      // compare as numbers: a disabled alert is saved as null or 0 but the form holds "0"
      Number((_workDaySettings$idle = workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.idleAlertMinutes) !== null && _workDaySettings$idle !== void 0 ? _workDaySettings$idle : 0) === Number((_values$idleAlertMinu = values.idleAlertMinutes) !== null && _values$idleAlertMinu !== void 0 ? _values$idleAlertMinu : 0) ? null : values.idleAlertMinutes,
      idleAlertOverride: workDaySettings.idleAlertOverride == null && values.idleAlertOverride == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.idleAlertOverride) === values.idleAlertOverride ? null : values.idleAlertOverride.toString(),
      idleMinutesThreshold: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.idleMinutesThreshold) === values.idleMinutesThreshold ? null : values.idleMinutesThreshold,
      workingHoursPerDay: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.workingHoursPerDay) === values.workingHoursPerDay ? null : values.workingHoursPerDay,
      productiveHours: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.productiveHours) === values.productiveHours ? null : values.productiveHours,
      organisationTimezone: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.organisationTimezone) === values.organisationTimezone ? null : values.organisationTimezone,
      idleTimeForRiskFactor: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.idleTimeForRiskFactor) === values.idleTimeForRiskFactor ? null : values.idleTimeForRiskFactor,
      workedHoursForRiskFactor: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.workedHoursForRiskFactor) === values.workedHoursForRiskFactor ? null : values.workedHoursForRiskFactor,
      unProductiveHoursForRiskFactor: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.unProductiveHoursForRiskFactor) === values.unProductiveHoursForRiskFactor ? null : values.unProductiveHoursForRiskFactor,
      projectManagementFeature: workDaySettings.projectManagementFeature == null && values.projectManagementFeature == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.projectManagementFeature) === values.projectManagementFeature ? null : values.projectManagementFeature.toString(),
      manualTimeFeature: workDaySettings.manualTimeFeature == null && values.manualTimeFeature == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.manualTimeFeature) === values.manualTimeFeature ? null : values.manualTimeFeature.toString(),
      adminCheck: workDaySettings.adminCheck == null && values.adminCheck == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.adminCheck) === values.adminCheck ? null : values.adminCheck.toString(),
      addProjectDetails: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.addProjectDetails) === values.addProjectDetails ? null : values.addProjectDetails,
      allowAdminAndHeadsToAddAProject: workDaySettings.allowAdminAndHeadsToAddAProject == null && values.allowAdminAndHeadsToAddAProject == false || workDaySettings.allowAdminAndHeadsToAddAProject === values.allowAdminAndHeadsToAddAProject ? null : values.allowAdminAndHeadsToAddAProject,
      allowEveryoneToAddProject: workDaySettings.allowEveryoneToAddProject == null && values.allowEveryoneToAddProject == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowEveryoneToAddProject) === values.allowEveryoneToAddProject ? null : values.allowEveryoneToAddProject,
      addTaskDetails: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.addTaskDetails) === values.addTaskDetails ? null : values.addTaskDetails,
      allowAdminHeadToAddTaskInProject: workDaySettings.allowAdminHeadToAddTaskInProject == null && values.allowAdminHeadToAddTaskInProject == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowAdminHeadToAddTaskInProject) === values.allowAdminHeadToAddTaskInProject ? null : values.allowAdminHeadToAddTaskInProject,
      allowEveryoneToAddTaskInProject: workDaySettings.allowEveryoneToAddTaskInProject == null && values.allowEveryoneToAddTaskInProject == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowEveryoneToAddTaskInProject) === values.allowEveryoneToAddTaskInProject ? null : values.allowEveryoneToAddTaskInProject,
      offlineTask: workDaySettings.offlineTask == null && values.offlineTask == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.offlineTask) === values.offlineTask ? null : values.offlineTask.toString(),
      allowMemberToAccessScreenCapture: workDaySettings.allowMemberToAccessScreenCapture == null && values.allowMemberToAccessScreenCapture == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowMemberToAccessScreenCapture) === values.allowMemberToAccessScreenCapture ? null : values.allowMemberToAccessScreenCapture.toString(),
      allowMemberToDeleteScreenCapture: workDaySettings.allowMemberToDeleteScreenCapture == null && values.allowMemberToDeleteScreenCapture == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowMemberToDeleteScreenCapture) === values.allowMemberToDeleteScreenCapture ? null : values.allowMemberToDeleteScreenCapture.toString(),
      allowHeadToDeleteTeamMemberScreenCapture: workDaySettings.allowHeadToDeleteTeamMemberScreenCapture == null && values.allowHeadToDeleteTeamMemberScreenCapture == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowHeadToDeleteTeamMemberScreenCapture) === values.allowHeadToDeleteTeamMemberScreenCapture ? null : values.allowHeadToDeleteTeamMemberScreenCapture.toString(),
      allowMemberToAccessTimesheet: workDaySettings.allowMemberToAccessTimesheet == null && values.allowMemberToAccessTimesheet == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowMemberToAccessTimesheet) === values.allowMemberToAccessTimesheet ? null : values.allowMemberToAccessTimesheet.toString(),
      allowMemberToAccessTimelapseVideo: workDaySettings.allowMemberToAccessTimelapseVideo == null && values.allowMemberToAccessTimelapseVideo == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowMemberToAccessTimelapseVideo) === values.allowMemberToAccessTimelapseVideo ? null : values.allowMemberToAccessTimelapseVideo.toString(),
      stealthMode: workDaySettings.stealthMode == null && values.stealthMode == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.stealthMode) === values.stealthMode ? null : values.stealthMode.toString(),
      reportSettings: workDaySettings.reportSettings == null && values.reportSettings == "Show-all-users-in-report" || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.reportSettings) === values.reportSettings ? null : values.reportSettings.toString(),
      organisationCurrencie: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.organisationCurrencie) == null && values.organisationCurrencie == "USD" || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.organisationCurrencie) === values.organisationCurrencie ? null : values.organisationCurrencie,
      organisationId: organisationId,
      timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
      expectedClockInTime: values.expectedClockInTime == null ? "" : moment(workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.expectedClockInTime).format("h:mm a") === moment(values.expectedClockInTime).format("h:mm a") ? null : moment(values.expectedClockInTime).format("h:mm a"),
      // allowHeadsToReviewApps: null,
      allowHeadsToReviewApps: workDaySettings.allowHeadsToReviewApps == null && values.allowHeadsToReviewApps == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowHeadsToReviewApps) === values.allowHeadsToReviewApps ? null : values.allowHeadsToReviewApps.toString(),
      allowTheEmployeeToAccessWebsite: workDaySettings.allowTheEmployeeToAccessWebsite == null && values.allowTheEmployeeToAccessWebsite == true || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowTheEmployeeToAccessWebsite) === values.allowTheEmployeeToAccessWebsite ? null : values.allowTheEmployeeToAccessWebsite.toString(),
      hideTheAdminDataFromAllPages: workDaySettings.hideTheAdminDataFromAllPages == null && values.hideTheAdminDataFromAllPages == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.hideTheAdminDataFromAllPages) === values.hideTheAdminDataFromAllPages ? null : values.hideTheAdminDataFromAllPages.toString(),
      hideTheTeamHeadDataFromAllPages: workDaySettings.hideTheTeamHeadDataFromAllPages == null && values.hideTheTeamHeadDataFromAllPages == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.hideTheTeamHeadDataFromAllPages) === values.hideTheTeamHeadDataFromAllPages ? null : values.hideTheTeamHeadDataFromAllPages.toString(),
      autoClockIn: workDaySettings.autoClockIn == null && values.autoClockIn == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.autoClockIn) === values.autoClockIn ? null : values.autoClockIn.toString(),
      leaveManagementFeature: workDaySettings.leaveManagementFeature == null && values.leaveManagementFeature == true || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.leaveManagementFeature) === values.leaveManagementFeature ? null : values.leaveManagementFeature.toString(),
      excludeUntrackedHours: workDaySettings.excludeUntrackedHours == null && values.excludeUntrackedHours == "false" || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.excludeUntrackedHours) === values.excludeUntrackedHours ? null : values.excludeUntrackedHours.toString(),
      allowEmployeesToManageTheirTasks: workDaySettings.allowEmployeesToManageTheirTasks == null && values.allowEmployeesToManageTheirTasks == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowEmployeesToManageTheirTasks) === values.allowEmployeesToManageTheirTasks ? null : values.allowEmployeesToManageTheirTasks.toString(),
      allowEmployeesToMarkTheirTasksAsCompleted: workDaySettings.allowEmployeesToMarkTheirTasksAsCompleted == null && values.allowEmployeesToMarkTheirTasksAsCompleted == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowEmployeesToMarkTheirTasksAsCompleted) === values.allowEmployeesToMarkTheirTasksAsCompleted ? null : values.allowEmployeesToMarkTheirTasksAsCompleted.toString(),
      automaticTaskTimer: workDaySettings.automaticTaskTimer == null && values.automaticTaskTimer == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.automaticTaskTimer) === values.automaticTaskTimer ? null : values.automaticTaskTimer.toString(),
      restrictNewTaskWhenPending: workDaySettings.restrictNewTaskWhenPending == null && values.restrictNewTaskWhenPending == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.restrictNewTaskWhenPending) === values.restrictNewTaskWhenPending ? null : values.restrictNewTaskWhenPending.toString(),
      allowEmployeesToEditTaskTimes: workDaySettings.allowEmployeesToEditTaskTimes == null && values.allowEmployeesToEditTaskTimes == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowEmployeesToEditTaskTimes) === values.allowEmployeesToEditTaskTimes ? null : values.allowEmployeesToEditTaskTimes.toString(),
      holidayMailCheck: workDaySettings.holidayMailCheck == null && values.holidayMailCheck == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.holidayMailCheck) === values.holidayMailCheck ? null : values.holidayMailCheck.toString(),
      enablePersonWiseTimezone: workDaySettings.enablePersonWiseTimezone == null && values.enablePersonWiseTimezone == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.enablePersonWiseTimezone) === values.enablePersonWiseTimezone ? null : values.enablePersonWiseTimezone.toString(),
      manualTimeMailCheck: workDaySettings.manualTimeMailCheck == null && values.manualTimeMailCheck == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.manualTimeMailCheck) === values.manualTimeMailCheck ? null : values.manualTimeMailCheck.toString(),
      enableSalaryCalculator: workDaySettings.enableSalaryCalculator == null && values.enableSalaryCalculator == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.enableSalaryCalculator) === values.enableSalaryCalculator ? null : values.enableSalaryCalculator.toString(),
      payrollCurrency: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.payrollCurrency) == null && values.payrollCurrency == "USD" || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.payrollCurrency) === values.payrollCurrency ? null : values.payrollCurrency,
      payrollCycle: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.payrollCycle) === values.payrollCycle ? null : values.payrollCycle,
      payrollWeekStartsOn: values.payrollCycle === "weekly" || values.payrollCycle === "bi-weekly" ? (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.payrollWeekStartsOn) === values.payrollWeekStartsOn ? null : values.payrollWeekStartsOn : null,
      keyStrokeCounter: workDaySettings.keyStrokeCounter == null && values.keyStrokeCounter == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.keyStrokeCounter) === values.keyStrokeCounter ? null : values.keyStrokeCounter.toString(),
      mouseTracker: workDaySettings.mouseTracker == null && values.mouseTracker == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.mouseTracker) === values.mouseTracker ? null : values.mouseTracker.toString(),
      allowEmailNotificationWhenTaskStatusChange: workDaySettings.allowEmailNotificationWhenTaskStatusChange == null && values.allowEmailNotificationWhenTaskStatusChange == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowEmailNotificationWhenTaskStatusChange) === values.allowEmailNotificationWhenTaskStatusChange ? null : values.allowEmailNotificationWhenTaskStatusChange.toString(),
      enableApiAccess: workDaySettings.enableApiAccess == null && values.enableApiAccess == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.enableApiAccess) === values.enableApiAccess ? null : values.enableApiAccess.toString(),
      enableRealTimeAlert: workDaySettings.enableRealTimeAlert == null && values.enableRealTimeAlert == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.enableRealTimeAlert) === values.enableRealTimeAlert ? null : values.enableRealTimeAlert.toString(),
      expectedActiveTime: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.expectedActiveTime) == null && values.expectedActiveTime == 420 || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.expectedActiveTime) === values.expectedActiveTime ? null : values.expectedActiveTime,
      planType: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
      // unchanged -> null; switched off -> "0"
      idleTimeStrictnessLevel: (Number(workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.idleTimeStrictnessLevel) > 0 ? String(workDaySettings.idleTimeStrictnessLevel) : null) === (values.idleTimeStrictnessLevel || null) ? null : values.idleTimeStrictnessLevel || "0",
      idleAlertBreak: workDaySettings.idleAlertBreak == null && values.idleAlertBreak == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.idleAlertBreak) === values.idleAlertBreak || values.idleAlertBreak == null ? null : values.idleAlertBreak.toString(),
      hideEditTrackSettingsFromTeamHeads: workDaySettings.hideEditTrackSettingsFromTeamHeads == null && values.hideEditTrackSettingsFromTeamHeads == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.hideEditTrackSettingsFromTeamHeads) === values.hideEditTrackSettingsFromTeamHeads ? null : values.hideEditTrackSettingsFromTeamHeads.toString(),
      enableProjectManagementDesktopUI: workDaySettings.enableProjectManagementDesktopUI == null && values.enableProjectManagementDesktopUI == false || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.enableProjectManagementDesktopUI) === values.enableProjectManagementDesktopUI ? null : values.enableProjectManagementDesktopUI.toString()
    };

    // payrollCycle can legitimately change to "Not applicable" (value: null),
    // which collides with the null "unchanged" sentinel the generic filter drops.
    // Detect a real change (treating "" / null as equivalent) so it still shows up.
    var normalizeCycle = function normalizeCycle(v) {
      return v || null;
    };
    var payrollCycleChanged = normalizeCycle(workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.payrollCycle) !== normalizeCycle(values.payrollCycle);
    var filteredVariables = Object.fromEntries(Object.entries(variables).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        v = _ref3[1];
      if (key === "payrollCycle") return payrollCycleChanged;
      // "0" turns the idle alert off, so a change to it must still be listed
      if (key === "idleAlertMinutes" && v === "0") return true;
      // "0" turns minimum activity off, so a change to it must still be listed
      if (key === "idleTimeStrictnessLevel" && v === "0") return true;
      return v !== null && v !== "" && v !== "0";
    }));
    setPendingFormValues(values);
    setUserShowSettingsUpdateModal(filteredVariables);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "timesheet-settings-card"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      workingDays: workDaySettings.workingDays !== null ? workDaySettings.workingDays.split(",") : ["Monday"],
      screenCapture: (_workDaySettings$scre = workDaySettings.screenCapture) !== null && _workDaySettings$scre !== void 0 ? _workDaySettings$scre : false,
      blurScreenCapture: (_workDaySettings$blur = workDaySettings.blurScreenCapture) !== null && _workDaySettings$blur !== void 0 ? _workDaySettings$blur : false,
      screenCaptureInterval: (_workDaySettings$scre2 = workDaySettings.screenCaptureInterval) !== null && _workDaySettings$scre2 !== void 0 ? _workDaySettings$scre2 : "1",
      generateTimelapseVideo: (_workDaySettings$gene = workDaySettings.generateTimelapseVideo) !== null && _workDaySettings$gene !== void 0 ? _workDaySettings$gene : false,
      workingHoursPerDay: (_workDaySettings$work = workDaySettings.workingHoursPerDay) !== null && _workDaySettings$work !== void 0 ? _workDaySettings$work : "480",
      productiveHours: (_workDaySettings$prod = workDaySettings.productiveHours) !== null && _workDaySettings$prod !== void 0 ? _workDaySettings$prod : "420",
      organisationTimezone: (_workDaySettings$orga = workDaySettings.organisationTimezone) !== null && _workDaySettings$orga !== void 0 ? _workDaySettings$orga : " ",
      //idleTime: workDaySettings.idleTime ?? "60",

      //trackAppsAndWebsites: workDaySettings.trackAppsAndWebsites ?? false,

      idleAlertMinutes: (_workDaySettings$idle2 = workDaySettings.idleAlertMinutes) !== null && _workDaySettings$idle2 !== void 0 ? _workDaySettings$idle2 : "0",
      idleAlertOverride: (_workDaySettings$idle3 = workDaySettings.idleAlertOverride) !== null && _workDaySettings$idle3 !== void 0 ? _workDaySettings$idle3 : "",
      idleMinutesThreshold: (_workDaySettings$idle4 = workDaySettings.idleMinutesThreshold) !== null && _workDaySettings$idle4 !== void 0 ? _workDaySettings$idle4 : "",
      projectManagementFeature: (_workDaySettings$proj = workDaySettings.projectManagementFeature) !== null && _workDaySettings$proj !== void 0 ? _workDaySettings$proj : false,
      manualTimeFeature: (_workDaySettings$manu = workDaySettings.manualTimeFeature) !== null && _workDaySettings$manu !== void 0 ? _workDaySettings$manu : false,
      adminCheck: (_workDaySettings$admi = workDaySettings.adminCheck) !== null && _workDaySettings$admi !== void 0 ? _workDaySettings$admi : false,
      addProjectDetails: (_workDaySettings$addP = workDaySettings.addProjectDetails) !== null && _workDaySettings$addP !== void 0 ? _workDaySettings$addP : "",
      addTaskDetails: (_workDaySettings$addT = workDaySettings.addTaskDetails) !== null && _workDaySettings$addT !== void 0 ? _workDaySettings$addT : "",
      offlineTask: (_workDaySettings$offl = workDaySettings.offlineTask) !== null && _workDaySettings$offl !== void 0 ? _workDaySettings$offl : false,
      // allowEmployeesToRateOfflineTask: workDaySettings.allowEmployeesToRateOfflineTask ?? false,

      allowMemberToAccessScreenCapture: (_workDaySettings$allo = workDaySettings.allowMemberToAccessScreenCapture) !== null && _workDaySettings$allo !== void 0 ? _workDaySettings$allo : false,
      allowMemberToDeleteScreenCapture: (_workDaySettings$allo2 = workDaySettings.allowMemberToDeleteScreenCapture) !== null && _workDaySettings$allo2 !== void 0 ? _workDaySettings$allo2 : false,
      allowHeadToDeleteTeamMemberScreenCapture: (_workDaySettings$allo3 = workDaySettings.allowHeadToDeleteTeamMemberScreenCapture) !== null && _workDaySettings$allo3 !== void 0 ? _workDaySettings$allo3 : false,
      allowMemberToAccessTimesheet: (_workDaySettings$allo4 = workDaySettings.allowMemberToAccessTimesheet) !== null && _workDaySettings$allo4 !== void 0 ? _workDaySettings$allo4 : false,
      allowMemberToAccessTimelapseVideo: (_workDaySettings$allo5 = workDaySettings.allowMemberToAccessTimelapseVideo) !== null && _workDaySettings$allo5 !== void 0 ? _workDaySettings$allo5 : false,
      //usbMonitoring: workDaySettings.usbMonitoring ?? false,
      stealthMode: (_workDaySettings$stea = workDaySettings.stealthMode) !== null && _workDaySettings$stea !== void 0 ? _workDaySettings$stea : false,
      reportSettings: (_workDaySettings$repo = workDaySettings.reportSettings) !== null && _workDaySettings$repo !== void 0 ? _workDaySettings$repo : "Show-all-users-in-report",
      scheduleStealthMode: (_workDaySettings$sche = workDaySettings.scheduleStealthMode) !== null && _workDaySettings$sche !== void 0 ? _workDaySettings$sche : false,
      startTime: (_workDaySettings$trac = workDaySettings.trackingStartTime) !== null && _workDaySettings$trac !== void 0 ? _workDaySettings$trac : "",
      endTime: (_workDaySettings$trac2 = workDaySettings.trackingEndTime) !== null && _workDaySettings$trac2 !== void 0 ? _workDaySettings$trac2 : "",
      expectedClockInTime: workDaySettings.expectedClockInTime ? moment(workDaySettings.expectedClockInTime) : undefined,
      allowHeadsToReviewApps: (_workDaySettings$allo6 = workDaySettings.allowHeadsToReviewApps) !== null && _workDaySettings$allo6 !== void 0 ? _workDaySettings$allo6 : false,
      allowTheEmployeeToAccessWebsite: (_workDaySettings$allo7 = workDaySettings.allowTheEmployeeToAccessWebsite) !== null && _workDaySettings$allo7 !== void 0 ? _workDaySettings$allo7 : true,
      organisationCurrencie: (_workDaySettings$orga2 = workDaySettings.organisationCurrencie) !== null && _workDaySettings$orga2 !== void 0 ? _workDaySettings$orga2 : "USD",
      hideTheAdminDataFromAllPages: (_workDaySettings$hide = workDaySettings.hideTheAdminDataFromAllPages) !== null && _workDaySettings$hide !== void 0 ? _workDaySettings$hide : false,
      hideTheTeamHeadDataFromAllPages: (_workDaySettings$hide2 = workDaySettings.hideTheTeamHeadDataFromAllPages) !== null && _workDaySettings$hide2 !== void 0 ? _workDaySettings$hide2 : false,
      // alertStartTime: workDaySettings.alertStartTime ?? alertStartTime,
      // alertEndTime: workDaySettings.alertEndTime ?? alertEndTime,

      autoClockIn: (_workDaySettings$auto = workDaySettings.autoClockIn) !== null && _workDaySettings$auto !== void 0 ? _workDaySettings$auto : false,
      leaveManagementFeature: workDaySettings.leaveManagementFeature == null ? true : workDaySettings.leaveManagementFeature ? workDaySettings.leaveManagementFeature : false,
      excludeUntrackedHours: workDaySettings.excludeUntrackedHours == "true" ? "true" : "false",
      allowEmployeesToManageTheirTasks: (_workDaySettings$allo8 = workDaySettings.allowEmployeesToManageTheirTasks) !== null && _workDaySettings$allo8 !== void 0 ? _workDaySettings$allo8 : false,
      allowEmployeesToMarkTheirTasksAsCompleted: (_workDaySettings$allo9 = workDaySettings.allowEmployeesToMarkTheirTasksAsCompleted) !== null && _workDaySettings$allo9 !== void 0 ? _workDaySettings$allo9 : false,
      automaticTaskTimer: (_workDaySettings$auto2 = workDaySettings.automaticTaskTimer) !== null && _workDaySettings$auto2 !== void 0 ? _workDaySettings$auto2 : false,
      restrictNewTaskWhenPending: (_workDaySettings$rest = workDaySettings.restrictNewTaskWhenPending) !== null && _workDaySettings$rest !== void 0 ? _workDaySettings$rest : false,
      // allowEmployeesToEditTaskTimes: workDaySettings.allowEmployeesToEditTaskTimes ?? false,
      holidayMailCheck: (_workDaySettings$holi = workDaySettings.holidayMailCheck) !== null && _workDaySettings$holi !== void 0 ? _workDaySettings$holi : false,
      enablePersonWiseTimezone: (_workDaySettings$enab = workDaySettings.enablePersonWiseTimezone) !== null && _workDaySettings$enab !== void 0 ? _workDaySettings$enab : false,
      allowEmployeesToEditTaskTimes: (workDaySettings.allowEmployeesToEditTaskTimes || workDaySettings.allowEmployeesToEditTaskTimes == undefined) && workDaySettings.projectManagementFeature == true ? true : false,
      manualTimeMailCheck: (_workDaySettings$manu2 = workDaySettings.manualTimeMailCheck) !== null && _workDaySettings$manu2 !== void 0 ? _workDaySettings$manu2 : false,
      enableSalaryCalculator: (_workDaySettings$enab2 = workDaySettings.enableSalaryCalculator) !== null && _workDaySettings$enab2 !== void 0 ? _workDaySettings$enab2 : false,
      payrollCurrency: (_workDaySettings$payr = workDaySettings.payrollCurrency) !== null && _workDaySettings$payr !== void 0 ? _workDaySettings$payr : "USD",
      payrollCycle: (_workDaySettings$payr2 = workDaySettings.payrollCycle) !== null && _workDaySettings$payr2 !== void 0 ? _workDaySettings$payr2 : null,
      payrollWeekStartsOn: (_workDaySettings$payr3 = workDaySettings.payrollWeekStartsOn) !== null && _workDaySettings$payr3 !== void 0 ? _workDaySettings$payr3 : "",
      keyStrokeCounter: (_workDaySettings$keyS = workDaySettings.keyStrokeCounter) !== null && _workDaySettings$keyS !== void 0 ? _workDaySettings$keyS : false,
      mouseTracker: (_workDaySettings$mous = workDaySettings.mouseTracker) !== null && _workDaySettings$mous !== void 0 ? _workDaySettings$mous : false,
      //mouseTrackerMovements: workDaySettings.mouseTrackerMovements == false ? true:false ?? false,
      allowEmailNotificationWhenTaskStatusChange: (_workDaySettings$allo10 = workDaySettings.allowEmailNotificationWhenTaskStatusChange) !== null && _workDaySettings$allo10 !== void 0 ? _workDaySettings$allo10 : false,
      enableApiAccess: (_workDaySettings$enab3 = workDaySettings.enableApiAccess) !== null && _workDaySettings$enab3 !== void 0 ? _workDaySettings$enab3 : false,
      enableRealTimeAlert: (_workDaySettings$enab4 = workDaySettings.enableRealTimeAlert) !== null && _workDaySettings$enab4 !== void 0 ? _workDaySettings$enab4 : false,
      expectedActiveTime: (_workDaySettings$expe = workDaySettings.expectedActiveTime) !== null && _workDaySettings$expe !== void 0 ? _workDaySettings$expe : "420",
      idleAlertBreak: (_workDaySettings$idle5 = workDaySettings.idleAlertBreak) !== null && _workDaySettings$idle5 !== void 0 ? _workDaySettings$idle5 : null,
      hideEditTrackSettingsFromTeamHeads: (_workDaySettings$hide3 = workDaySettings.hideEditTrackSettingsFromTeamHeads) !== null && _workDaySettings$hide3 !== void 0 ? _workDaySettings$hide3 : false,
      allowAdminAndHeadsToAddAProject: (_workDaySettings$allo11 = workDaySettings.allowAdminAndHeadsToAddAProject) !== null && _workDaySettings$allo11 !== void 0 ? _workDaySettings$allo11 : false,
      allowEveryoneToAddProject: (_workDaySettings$allo12 = workDaySettings.allowEveryoneToAddProject) !== null && _workDaySettings$allo12 !== void 0 ? _workDaySettings$allo12 : false,
      allowAdminHeadToAddTaskInProject: (_workDaySettings$allo13 = workDaySettings.allowAdminHeadToAddTaskInProject) !== null && _workDaySettings$allo13 !== void 0 ? _workDaySettings$allo13 : false,
      allowEveryoneToAddTaskInProject: (_workDaySettings$allo14 = workDaySettings.allowEveryoneToAddTaskInProject) !== null && _workDaySettings$allo14 !== void 0 ? _workDaySettings$allo14 : false,
      // idleAlertBreak: null,
      enableProjectManagementDesktopUI: (_workDaySettings$enab5 = workDaySettings.enableProjectManagementDesktopUI) !== null && _workDaySettings$enab5 !== void 0 ? _workDaySettings$enab5 : false,
      // minimum activity per minute: null = disabled, otherwise seconds of activity required
      idleTimeStrictnessLevel: Number(workDaySettings.idleTimeStrictnessLevel) > 0 ? String(workDaySettings.idleTimeStrictnessLevel) : null
    }
    // validationSchema={MembersSchema}
    // onSubmit={handleSubmit}
    ,
    onSubmit: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? handleSubmit : handleShowUserSettings
  }, function (_ref4) {
    var isSubmitting = _ref4.isSubmitting,
      values = _ref4.values,
      setFieldValue = _ref4.setFieldValue;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, {
      className: "timesheet-settings-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Work Day Settings"), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Choose work days"), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-worked-days-list"
    }, WorkingDaysList.map(function (workingDays, index) {
      var temp = workDaySettings.workingDays !== null ? workDaySettings.workingDays.split(",") : ["Monday"];
      var activeWorkingDaysData = temp.includes(workingDays);
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("timesheet-settings-worked-days-data")
        //onClick={() => selectWorkingDays(workingDays)}
      }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
        type: "checkbox",
        name: "workingDays",
        value: workingDays
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkbox-date"
      }, workingDays)));
    })))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Work Time Settings"), /*#__PURE__*/React.createElement(Field, {
      name: "workingHoursPerDay"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta,
        form = fieldProps.form;
      var workHourOptions = expectedWorkingHourData.map(function (key) {
        return {
          value: key.mins,
          label: key.hours
        };
      });
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Expected work hours "), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: workHourOptions.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: function onChange(selected) {
          return form.setFieldValue("workingHoursPerDay", selected ? selected.value : null);
        },
        options: workHourOptions,
        placeholder: "Select an hour",
        menuPosition: "fixed"
        // Match the 75% width of the neighboring native selects
        // (.timesheet-settings-card .form-control { width: 75% }).
        ,
        styles: {
          container: function container(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              width: "75%"
            });
          }
        }
        // Keep "(Recommended)" in the dropdown list, but hide it in the
        // selected (collapsed) value.
        ,
        formatOptionLabel: function formatOptionLabel(option, _ref5) {
          var context = _ref5.context;
          return context === "value" ? option.label.replace(/\s*\(Recommended\)/i, "") : option.label;
        }
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "productiveHours"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Expected productive apps usage time "), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        placeholder: "Select an hour"
      }, field), productiveWorkingHourData.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.mins,
          value: key.mins
        }, key.hours);
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "expectedActiveTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Expected active time (Excluding idle time from total work time)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        placeholder: "Select an hour"
      }, field), expectedWorkingHourData.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.mins,
          value: key.mins
        }, key.hours);
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "organisationTimezone"
    }, function (_ref6) {
      var field = _ref6.field,
        form = _ref6.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Organisation timezone"), /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: timezoneList.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: timezoneOfOnChange(form.setFieldValue),
        options: timezoneList
        //defaultMenuIsOpen={true}
        ,
        menuPosition: "fixed",
        className: "timesheet-settings-timzone-search"
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockInTime"
    }, function (_ref7) {
      var field = _ref7.field,
        form = _ref7.form,
        meta = _ref7.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Expected Clock-in"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "Clock-in Time",
        value: values === null || values === void 0 ? void 0 : values.expectedClockInTime,
        className: meta.error && meta.touched ? "track-settings-formik-add-form-start-time-error" : "track-settings-formik-add-form-start-time",
        onChange: function onChange(e) {
          expectedClockInOnChange(e, setFieldValue);
        },
        placeholder: "Clock-in Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined
        // clearIcon={null}
        ,
        inputReadOnly: true
        // disabledHours={disabledStartTimeHours}
        // disabledMinutes={disabledStartTimeMinutes}
      })));
    }), organisationId === "629823d0-ea16-11eb-8ecf-fd402ded7fa3" ? /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "enablePersonWiseTimezone",
      checked: values.enablePersonWiseTimezone,
      label: "Enable person wise timezone",
      id: "Enable-person-wise-timezone"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    }) : null), workDaySettings.stealthMode == true || organisationId == "f2c9e240-4e71-11eb-9784-794f853f90e2" && (window.location.href.includes("http://65.109.31.126") || window.location.href.includes("localhost")) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Stealth Mode", " ", /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "currently-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top",
        className: "track-setting-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, "If you enable the stealth mode, Tracking will be started automatically whenever your employee's system is ON."))
    }, /*#__PURE__*/React.createElement("span", {
      className: "track-setting-text-ques"
    }, " ", /*#__PURE__*/React.createElement(HiQuestionMarkCircle, null))), /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Beta")), planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade your plan to enable stealth mode")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check
      //name="screenCapture"
      ,
      checked: values.stealthMode,
      disabled: planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b",
      label: "Enable stealth mode to everyone",
      id: "stealth-mode",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    }))) : /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "stealthMode",
      checked: values.stealthMode,
      label: "Enable stealth mode to everyone",
      id: "stealth-mode",
      className: "track-settingts-checkbox"
    })), values.stealthMode == true ? /*#__PURE__*/React.createElement("label", {
      className: "track-setting-info-text"
    }, "Your team members\u2019 desktop app will operate in the background and be hidden if you enable stealth mode.") : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Project Management"), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "projectManagementFeature",
      checked: values.projectManagementFeature,
      label: "Enable project management",
      id: "Enable-project-management"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox",
      onChange: function onChange(e) {
        setFieldValue("projectManagementFeature", e.target.checked);
        if (e.target.checked == true) {
          setFieldValue("allowEmployeesToEditTaskTimes", e.target.checked);
        } else {
          setFieldValue("allowEmployeesToManageTheirTasks", e.target.checked);
          setFieldValue("allowEmployeesToMarkTheirTasksAsCompleted", e.target.checked);
          setFieldValue("allowEmployeesToEditTaskTimes", e.target.checked);
        }
      }
    })), window.location.href.includes("http://65.109.31.126") || window.location.href.includes("localhost") ? /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "enableProjectManagementDesktopUI",
      checked: values.enableProjectManagementDesktopUI,
      label: "Enable Project Management Desktop UI",
      id: "Enable-Project-Management-in-Desktop"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox",
      onChange: function onChange(e) {
        setFieldValue("enableProjectManagementDesktopUI", e.target.checked);
      }
    })) : null, planId !== "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || preminumPlanSetting ? /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowEmployeesToManageTheirTasks",
      checked: values.allowEmployeesToManageTheirTasks,
      label: "Allow team members to add, edit and delete their tasks",
      id: "Enable-employees-to-create-their-tasks",
      disabled: values.projectManagementFeature == true ? false : true,
      className: "enable-employees-to-create-their-tasks"
    })) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade your plan to allow employees to add, edit and delete their tasks.")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowEmployeesToManageTheirTasks",
      label: "Allow team members to add, edit and delete their tasks",
      id: "Enable-employees-to-create-their-tasks",
      disabled: true,
      className: "enable-employees-to-create-their-tasks"
    }))), planId !== "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || preminumPlanSetting ? /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowEmployeesToMarkTheirTasksAsCompleted",
      checked: values.allowEmployeesToMarkTheirTasksAsCompleted,
      label: "Allow team members to mark their tasks as completed & hold",
      id: "enable-task-completion-for-employees-hold-complete",
      disabled: values.projectManagementFeature == true ? false : true,
      className: "enable-task-completion-for-employees"
    })) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade your plan to allow employees to mark their tasks as completed & hold.")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowEmployeesToMarkTheirTasksAsCompleted",
      label: "Allow team members to mark their tasks as completed & hold",
      id: "enable-task-completion-for-employees-hold-complete",
      disabled: true,
      className: "enable-task-completion-for-employees"
    }))), planId !== "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || preminumPlanSetting ? /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowEmployeesToEditTaskTimes",
      checked: values.allowEmployeesToEditTaskTimes,
      label: "Allow team members to edit task times",
      id: "enable-employees-to-edit-task-times",
      disabled: values.projectManagementFeature == true ? false : true,
      className: "enable-employees-to-edit-task-times"
    })) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade your plan to allow employees to edit task times.")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowEmployeesToEditTaskTimes",
      label: "Allow team members to edit task times",
      id: "enable-employees-to-edit-task-times",
      disabled: true,
      className: "enable-employees-to-edit-task-times"
    }))), /*#__PURE__*/React.createElement("h6", null, "Advanced Features", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium")), (planId !== "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || preminumPlanSetting) && (planId !== "93844da8-71e8-4e94-b6ac-aaff5d8a858c" || preminumPlanSetting) ? /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowEmailNotificationWhenTaskStatusChange",
      checked: values.allowEmailNotificationWhenTaskStatusChange,
      label: "Send email notifications to associated users when the task status changes.",
      id: "enable-email-notification-project-employees",
      disabled: values.projectManagementFeature == true ? false : true,
      className: "enable-task-completion-for-employees"
    })) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade premium plan to enable send email notifications to associated users when the task status changes.")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowEmailNotificationWhenTaskStatusChange",
      label: "Send email notifications to associated users when the task status changes.",
      id: "enable-email-notification-project-employees",
      disabled: true,
      className: "enable-task-completion-for-employees"
    }))), (planId !== "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || preminumPlanSetting) && (planId !== "93844da8-71e8-4e94-b6ac-aaff5d8a858c" || preminumPlanSetting) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "automaticTaskTimer",
      checked: values.automaticTaskTimer,
      label: "Auto start and end task using current time",
      id: "auto-start-and-end-task-using-current-time",
      disabled: values.projectManagementFeature == true ? false : true,
      className: "enable-task-completion-for-employees"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-muted ms-4 track-setting-radion-button-idle-note"
    }, "When enabled, the task start and end time will be recorded automatically based on when the employee clicks the start and stop buttons."))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "restrictNewTaskWhenPending",
      checked: values.restrictNewTaskWhenPending,
      label: "Restrict new tasks when a previous task is pending",
      id: "restrict-new-tasks-when-a-previous-task-is-pending",
      disabled: values.automaticTaskTimer == true ? false : true,
      className: "enable-task-completion-for-employees"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-muted ms-4 track-setting-radion-button-idle-note"
    }, "When enabled, employees cannot start a new task if their previous task is not completed or ended.")))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade premium plan to enable auto start and end task using current time.")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check
      //name="automaticTaskTimer"
      ,
      checked: values.automaticTaskTimer,
      label: "Auto start and end task using current time",
      id: "auto-start-and-end-task-using-current-time",
      disabled: true,
      className: "enable-task-completion-for-employees"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-muted ms-4 track-setting-radion-button-idle-note"
    }, "When enabled, the task start and end time will be recorded automatically based on when the employee clicks the start and stop buttons.")))), /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade premium plan to enable restrict new tasks when a previous task is pending.")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check
      //name="restrictNewTaskWhenPending"
      ,
      checked: values.restrictNewTaskWhenPending,
      label: "Restrict new tasks when a previous task is pending",
      id: "restrict-new-tasks-when-a-previous-task-is-pending",
      disabled: true,
      className: "enable-task-completion-for-employees"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-muted ms-4 track-setting-radion-button-idle-note"
    }, "When enabled, employees cannot start a new task if their previous task is not completed or ended."))))), /*#__PURE__*/React.createElement(Field, {
      name: "organisationCurrencie"
    }, function (_ref8) {
      var field = _ref8.field,
        form = _ref8.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Project currency"), /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: currenciesList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: currencyOfOnChange(form.setFieldValue),
        options: currenciesList
        //defaultMenuIsOpen={true}
        ,
        isDisabled: values.projectManagementFeature === true ? false : true,
        menuPosition: "fixed",
        className: "timesheet-settings-timzone-search"
      })));
    }))
    // ) : null
    , /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Leave Management "), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "leaveManagementFeature",
      checked: values.leaveManagementFeature,
      label: "Enable leave management",
      id: "Enable-leave-management"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    }))), organisationId == "f2c9e240-4e71-11eb-9784-794f853f90e2" && (window.location.href.includes("http://65.109.31.126") || window.location.href.includes("localhost")) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Auto Clock-in Feature", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Beta"), /*#__PURE__*/React.createElement("span", {
      className: "timesheet-settings-row-grid-card-auto-clock-in-card-header-span"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://workfolio.tawk.help/article/auto-clock-in-feature-in-workfolio",
      target: "_blank"
    }, "How it works?"))), planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade your plan to enable Auto Clock-in Feature")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check
      //name="screenCapture"
      ,
      checked: values.manualTimeFeature,
      disabled: planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b",
      label: "Enable the auto clock-in feature to everyone",
      id: "auto-clock-in",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    }))) : /*#__PURE__*/React.createElement(Form.Group, {
      className: "timesheet-settings-row-grid-card-manual-time-card-header"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "autoClockIn",
      checked: values.autoClockIn,
      label: "Enable the auto clock-in feature to everyone",
      id: "auto-clock-in",
      className: "track-settingts-checkbox"
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Manual Time "), planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade your plan to enable Manual time")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check
      //name="screenCapture"
      ,
      checked: values.manualTimeFeature,
      disabled: planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b",
      label: "Enable manual time to everyone",
      id: "manual-time-feature",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
      className: "timesheet-settings-row-grid-card-manual-time-card-header"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "manualTimeFeature",
      checked: values.manualTimeFeature,
      label: "Enable manual time to everyone",
      id: "manual-time-feature",
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement("span", {
      className: "timesheet-settings-row-grid-card-manual-time-card-header-span"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://workfolio.tawk.help/article/how-does-a-manual-task-works",
      target: "_blank"
    }, "(Learn more)"))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "manualTimeMailCheck",
      checked: values.manualTimeMailCheck,
      label: "Send manual time notifications to admins",
      id: "send-manual-time-notification-to-admins"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Untracked (Internet-Interrupted) Hours Settings "), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "timesheet-settings-row-grid-card-internet-interrupt-question"
    }, "Exclude hours with internet interruptions in total work hours?"), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-internet-interrupt-label"
    }, /*#__PURE__*/React.createElement(Form.Group, {
      className: "timesheet-settings-row-grid-card-internet-interrupt-label-include"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "excludeUntrackedHours",
      value: "true",
      checked: values.excludeUntrackedHours === "true" // Explicitly check the condition
      ,
      onClick: function onClick(e) {
        setFieldValue("excludeUntrackedHours", e.target.value);
      }
    }), /*#__PURE__*/React.createElement("span", null, "Yes - Exclude the untracked hours from total work time"))), /*#__PURE__*/React.createElement(Form.Group, {
      className: "timesheet-settings-row-grid-card-internet-interrupt-label-exclude"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "excludeUntrackedHours",
      value: "false",
      checked: values.excludeUntrackedHours === "false" // Explicitly check the condition
      ,
      onClick: function onClick(e) {
        setFieldValue("excludeUntrackedHours", e.target.value);
      }
    }), /*#__PURE__*/React.createElement("span", null, "No - Include the untracked hours to total work time")))))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Payroll Settings", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium")), (planId !== "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || preminumPlanSetting) && (planId !== "93844da8-71e8-4e94-b6ac-aaff5d8a858c" || preminumPlanSetting) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "enableSalaryCalculator",
      checked: values.enableSalaryCalculator,
      label: "Enable Payroll Calculator",
      id: "enable-salary-calculator"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })), /*#__PURE__*/React.createElement(Field, {
      name: "payrollCurrency"
    }, function (_ref9) {
      var field = _ref9.field,
        form = _ref9.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Payroll currency"), /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: payrollCurrenciesList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(e) {
          if (e) {
            setFieldValue("payrollCurrency", e.value);
          } else {
            setFieldValue("payrollCurrency", []);
          }
        },
        options: payrollCurrenciesList
        //defaultMenuIsOpen={true}
        ,
        isDisabled: values.enableSalaryCalculator === true ? false : true,
        menuPosition: "fixed",
        className: "timesheet-settings-timzone-search"
      })));
    }), values.enableSalaryCalculator == true ? /*#__PURE__*/React.createElement("div", {
      className: "payroll-cycle-section"
    }, /*#__PURE__*/React.createElement("h6", {
      className: "payroll-cycle-section-title"
    }, "Payroll Cycle"), /*#__PURE__*/React.createElement("p", {
      className: "payroll-cycle-section-subtitle"
    }, "Organization-wide setting applied to all employees"), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement("div", {
      className: "payroll-cycle-card-list"
    }, PayrollCycleList.map(function (payrollCycle, index) {
      var _payrollCycle$value;
      var CycleIcon = PayrollCycleIcons[payrollCycle.icon];
      // Treat null/undefined/"" as "Not applicable" (value: null)
      var isActive = (values.payrollCycle || null) === payrollCycle.value;
      return /*#__PURE__*/React.createElement("div", {
        key: (_payrollCycle$value = payrollCycle.value) !== null && _payrollCycle$value !== void 0 ? _payrollCycle$value : "not-applicable",
        className: classNames("payroll-cycle-card", {
          "payroll-cycle-card-active": isActive
        }),
        onClick: function onClick() {
          setFieldValue("payrollCycle", payrollCycle.value);
          // Weekly / bi-weekly need a week start; default to Monday
          // when none is set yet (keeps any existing choice).
          if ((payrollCycle.value === "weekly" || payrollCycle.value === "bi-weekly") && !values.payrollWeekStartsOn) {
            setFieldValue("payrollWeekStartsOn", "monday");
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "payroll-cycle-card-header"
      }, CycleIcon ? /*#__PURE__*/React.createElement(CycleIcon, {
        className: "payroll-cycle-card-icon"
      }) : null, /*#__PURE__*/React.createElement("span", {
        className: "payroll-cycle-card-label"
      }, payrollCycle.label)), /*#__PURE__*/React.createElement("span", {
        className: "payroll-cycle-card-description"
      }, payrollCycle.description));
    }))), values.payrollCycle === "weekly" || values.payrollCycle === "bi-weekly" ? /*#__PURE__*/React.createElement("div", {
      className: "week-starts-on-section"
    }, /*#__PURE__*/React.createElement("span", {
      className: "week-starts-on-title"
    }, "WEEK STARTS ON"), /*#__PURE__*/React.createElement("div", {
      className: "week-starts-on-list"
    }, WeekStartDaysList.map(function (day) {
      var isActive = values.payrollWeekStartsOn === day.value;
      return /*#__PURE__*/React.createElement("div", {
        key: day.value,
        className: classNames("week-starts-on-day", {
          "week-starts-on-day-active": isActive
        }),
        onClick: function onClick() {
          return setFieldValue("payrollWeekStartsOn", day.value);
        }
      }, day.label);
    }))) : null) : null) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade premium plan to enable payroll settings")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "enableSalaryCalculator",
      disabled: planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || planId === "93844da8-71e8-4e94-b6ac-aaff5d8a858c",
      label: "Enable Payroll Calculator",
      id: "enable-salary-calculator"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })))), preminumPlanSetting ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Keyboard & Mouse Activity Tracking", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium"), " ", /*#__PURE__*/React.createElement("span", {
      className: "timesheet-settings-row-grid-card-manual-time-card-header-span-mouse"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://workfolio.tawk.help/article/keyboard-mouse-activity-tracking",
      target: "_blank"
    }, "(Learn more)"))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "keyStrokeCounter",
      checked: values.keyStrokeCounter,
      label: "Enable Track Keypress Count on Windows",
      id: "enable-keypress-tracking"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement("p", {
      className: "timesheet-settings-row-grid-card-mouse-p"
    }, "Tracks how many keys a user presses during work hours.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "mouseTracker",
      checked: values.mouseTracker,
      label: "Enable Mouse Activity Tracking on Windows",
      id: "enable-mouse-activity-tracking"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement("p", {
      className: "timesheet-settings-row-grid-card-mouse-p"
    }, "Tracks mouse clicks, scrolls, and movement to measure interaction.")), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-note-text"
    }, " ", /*#__PURE__*/React.createElement("a", {
      href: "/reports/input-activity-report",
      style: {
        color: "#3f51b5",
        textDecoration: "underline",
        cursor: "pointer"
      }
    }, "Here is the link", " "), " ", "to see the keyboard and mouse activities report")) : /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Keyboard & Mouse Activity Tracking", " ", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium"), /*#__PURE__*/React.createElement("span", {
      className: "timesheet-settings-row-grid-card-manual-time-card-header-span"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://workfolio.tawk.help/article/keyboard-mouse-activity-tracking",
      target: "_blank"
    }, "(Learn more)"))), /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade to premium plan to enable Keyboard & Mouse Activity Tracking")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "keyStrokeCounter",
      disabled: true,
      label: "Enable Track Keypress Count on Windows",
      id: "enable-keypress-tracking",
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement("p", {
      className: "timesheet-settings-row-grid-card-mouse-p"
    }, "Tracks how many keys a user presses during work hours."))), /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade to premium plan to enable Keyboard & Mouse Activity Tracking")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "mouseTracker",
      disabled: true,
      label: "Enable Mouse Activity Tracking on Windows",
      id: "enable-mouse-activity-tracking"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement("p", {
      className: "timesheet-settings-row-grid-card-mouse-p"
    }, "Tracks mouse clicks, scrolls, and movement to measure interaction.")))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Email Report Settings"), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Show all users in report",
      value: "Show-all-users-in-report",
      name: "reportSettings",
      id: "Show-all-users-in-report",
      className: "track-setting-radion-button"
    }), /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Exclude admin users in report",
      value: "Exclude-admin-users-in-report",
      name: "reportSettings",
      id: "Exclude-admin-users-in-report",
      className: "track-setting-radion-button-exclude track-setting-radion-button"
    }), /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Exclude admin & head users in report",
      value: "Exclude-admin-head-users-in-report",
      name: "reportSettings",
      id: "Exclude-admin-head-users-in-report",
      className: "track-setting-radion-button-exclude"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Screenshot Settings"), planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade your plan to change track settings")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check
      //name="screenCapture"
      ,
      checked: values.screenCapture,
      disabled: planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b",
      label: "Enable screen capture",
      id: "Enable-screen-capture"
      //isInvalid={emailError != null}
    }))) : /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "screenCapture",
      checked: values.screenCapture,
      label: "Enable screen capture",
      id: "Enable-screen-capture",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "blurScreenCapture",
      disabled: values.screenCapture === true ? false : true,
      checked: values.blurScreenCapture,
      label: "Blur screen capture",
      id: "Blur-screen-capture",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Field, {
      name: "screenCaptureInterval"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta,
        form = fieldProps.form;
      var screenshotOptions = ScreenshotList.map(function (w) {
        return {
          value: w.minsvalue,
          label: w.mins
        };
      });
      var screenshotFreeOptions = ScreenshotListFreePlan.map(function (w) {
        return {
          value: w.minsvalue,
          label: w.mins
        };
      });
      var isCaptureDisabled = values.screenCapture === true ? false : true;
      // Keep "(Recommended)" in the dropdown list, but hide it in the selected value.
      var formatInterval = function formatInterval(option, _ref10) {
        var context = _ref10.context;
        return context === "value" ? option.label.replace(/\s*\(Recommended\)/i, "") : option.label;
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(Form.Group, {
        "data-tip": true,
        "data-for": "registerTip",
        "data-background-color": "#535C68",
        "data-class": "react-tooltip-free-setting"
      }, /*#__PURE__*/React.createElement(ReactTooltip, {
        id: "registerTip",
        place: "bottom",
        effect: "solid"
      }, "Please upgrade your plan to change screen capture interval", " "), /*#__PURE__*/React.createElement(Form.Label, {
        disabled: isCaptureDisabled
      }, "Screen capture interval", " "), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        isDisabled: isCaptureDisabled,
        value: screenshotFreeOptions.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: function onChange(selected) {
          return form.setFieldValue("screenCaptureInterval", selected ? selected.value : null);
        },
        options: screenshotFreeOptions,
        isOptionDisabled: function isOptionDisabled(option) {
          return planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" && option.value !== "10";
        },
        placeholder: "Select an interval",
        menuPosition: "fixed",
        formatOptionLabel: formatInterval,
        styles: {
          container: function container(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              width: "75%"
            });
          }
        }
      }))) : /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        disabled: isCaptureDisabled
      }, "Screen capture interval", " "), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        isDisabled: isCaptureDisabled,
        value: screenshotOptions.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: function onChange(selected) {
          return form.setFieldValue("screenCaptureInterval", selected ? selected.value : null);
        },
        options: screenshotOptions,
        isOptionDisabled: function isOptionDisabled(option) {
          return planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" && option.value !== "5";
        },
        placeholder: "Select an interval",
        menuPosition: "fixed",
        formatOptionLabel: formatInterval,
        styles: {
          container: function container(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              width: "75%"
            });
          }
        }
      }))));
    }), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" && organisationBilling.isTrial == true ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please purchase pro plan to enable the timelapse video")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "generateTimelapseVideo",
      checked: values.generateTimelapseVideo,
      disabled: true,
      label: "Allow to generate timelapse video",
      id: "Allow-to-generate-timelapse-video",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    }))) : /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "generateTimelapseVideo",
      checked: values.generateTimelapseVideo,
      disabled: values.screenCapture === true ? false : true,
      label: "Allow to generate timelapse video",
      id: "Allow-to-generate-timelapse-video",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    }))
    // ) : null
    ), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Idle Time Settings"), /*#__PURE__*/React.createElement(Field, {
      name: "idleMinutesThreshold"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta,
        form = fieldProps.form;
      var idleThresholdOptions = IdelTimeThresholdList.map(function (w) {
        return {
          value: w.minsvalue,
          label: w.mins
        };
      });
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Start to consider as idle if the employee is inactive for", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: idleThresholdOptions.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: function onChange(selected) {
          return form.setFieldValue("idleMinutesThreshold", selected ? selected.value : null);
        },
        options: idleThresholdOptions,
        placeholder: "Select a minutes",
        menuPosition: "fixed"
        // Keep "(Recommended)" in the dropdown list, but hide it in the selected value.
        ,
        formatOptionLabel: function formatOptionLabel(option, _ref11) {
          var context = _ref11.context;
          return context === "value" ? option.label.replace(/\s*\(Recommended\)/i, "") : option.label;
        },
        styles: {
          container: function container(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              display: "inline-block",
              verticalAlign: "middle",
              minWidth: "200px",
              marginLeft: "8px",
              marginTop: "0.5rem"
            });
          }
        }
      })))), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null);
    }), workDaySettings.idleAlertMinutes > 0 || (organisationId == "f2c9e240-4e71-11eb-9784-794f853f90e2" || organisationBilling.planName == "premium") && (window.location.href.includes("http://65.109.31.126") || window.location.href.includes("localhost")) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "idle-alert-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "custom-control custom-switch idle-alert-switch"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "custom-control-input",
      id: "customSwitch",
      checked: isToggledIdleAlert,
      onChange: function onChange(e) {
        // localStorage?.setItem?.("timezone", isToggled ? "userTimezone" : "organisationTimezone");

        setIsToggledIdleAlert(!isToggledIdleAlert);
        setFieldValue("idleAlertMinutes", "0");
        if (!isToggledIdleAlert == false) {
          setFieldValue("idleAlertMinutes", "0");
          setFieldValue("idleAlertOverride", !isToggledIdleAlert);
          setFieldValue("idleAlertBreak", null);
        } else {
          var _workDaySettings$idle6;
          setFieldValue("idleAlertMinutes", "1");
          setFieldValue("idleAlertBreak", (_workDaySettings$idle6 = workDaySettings.idleAlertBreak) !== null && _workDaySettings$idle6 !== void 0 ? _workDaySettings$idle6 : "true");
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "custom-control-label",
      htmlFor: "customSwitch"
    })), /*#__PURE__*/React.createElement("h6", null, "Idle Alert Trigger", " ", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium"), /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Beta"))), /*#__PURE__*/React.createElement(Field, {
      name: "idleAlertMinutes"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Automatically send an in-app alert and pause the work timer if the employee remains idle for more than", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        className: "user-employee-idle-dropdown",
        disabled: !isToggledIdleAlert,
        placeholder: "Select a minutes"
      }, field), /*#__PURE__*/React.createElement("option", {
        value: "0",
        disabled: workDaySettings.idleAlertMinutes
      }, "Select a minutes"), IdelTimeThresholdList.map(function (workingDays) {
        return /*#__PURE__*/React.createElement("option", {
          key: workingDays.minsvalue,
          value: workingDays.minsvalue
        }, workingDays.mins);
        // }
      })))), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, isToggledIdleAlert && values.idleAlertMinutes != "" ? /*#__PURE__*/React.createElement("span", {
        className: "user-employee-idle-note-text"
      }, "Note: If team members remain idle for more than", " ", Number(values.idleMinutesThreshold) + Number(values.idleAlertMinutes), " minutes, they will receive an alert.") : null);
    }), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "idleAlertOverride",
      checked: values.idleAlertOverride,
      disabled: !isToggledIdleAlert,
      label: "Show idle alerts even for apps excluded from idle detection",
      id: "idle-alert-overwrite",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), isToggledIdleAlert ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-idle-alert-action-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Idle Alert Action"), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement("div", {
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Show popup only",
      value: "false",
      name: "idleAlertBreak",
      id: "show-popup-only",
      className: "track-setting-radion-button-idle"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-muted ms-4 track-setting-radion-button-idle-note"
    }, "Displays an idle warning but continues the work timer")), /*#__PURE__*/React.createElement("div", {
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Show popup and pause work timer",
      value: "true",
      name: "idleAlertBreak",
      id: "show-popup-and-pause-work-timer",
      className: "track-setting-radion-button-exclude track-setting-radion-button-idle"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-muted ms-4 track-setting-radion-button-idle-note"
    }, "Sends an alert and automatically pauses the timer")))) : null) : null), organisationBilling.planName != "free" && (window.location.href.includes("http://65.109.31.126") || window.location.href.includes("localhost")) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", {
      className: ""
    }, "Minimum activity per minute"), /*#__PURE__*/React.createElement("p", {
      className: "minimum-activity-description"
    }, "Count a minute as active only when the employee has at least the selected amount of computer activity during that minute."), /*#__PURE__*/React.createElement("div", {
      className: "idle-alert-wrapper minimum-activity-toggle-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "custom-control custom-switch idle-alert-switch"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "custom-control-input",
      id: "minimumActivitySwitch",
      checked: minimumActivityEnabled,
      onChange: function onChange() {
        setMinimumActivityEnabled(!minimumActivityEnabled);
        if (minimumActivityEnabled) {
          // switching off: no minimum activity level
          setFieldValue("idleTimeStrictnessLevel", null);
        } else {
          // switching on: restore the saved level, or default to 5 sec
          setFieldValue("idleTimeStrictnessLevel", Number(workDaySettings.idleTimeStrictnessLevel) > 0 ? String(workDaySettings.idleTimeStrictnessLevel) : "5");
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "custom-control-label",
      htmlFor: "minimumActivitySwitch"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
      className: ""
    }, "Require minimum activity"), /*#__PURE__*/React.createElement("p", {
      className: "minimum-activity-toggle-note"
    }, "When disabled, every minute with any activity (even a few seconds) will be counted as active. This condition will not be applied."))), minimumActivityEnabled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
      className: "minimum-activity-required-label"
    }, "Minimum activity required"), /*#__PURE__*/React.createElement("div", {
      className: "minimum-activity-segment",
      role: "radiogroup",
      "aria-label": "Minimum activity required"
    }, ["5", "10", "20"].map(function (seconds) {
      return /*#__PURE__*/React.createElement("button", {
        key: seconds,
        type: "button",
        role: "radio",
        "aria-checked": values.idleTimeStrictnessLevel === seconds,
        className: "minimum-activity-segment-option ".concat(values.idleTimeStrictnessLevel === seconds ? "minimum-activity-segment-option-active" : ""),
        onClick: function onClick() {
          setFieldValue("idleTimeStrictnessLevel", seconds);
        }
      }, seconds, " sec");
    })), /*#__PURE__*/React.createElement("p", {
      className: "minimum-activity-example"
    }, /*#__PURE__*/React.createElement("strong", null, "Example:"), " With ", values.idleTimeStrictnessLevel, " sec selected, a minute counts as active when activity is detected for at least ", values.idleTimeStrictnessLevel, " seconds.")) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Permissions"), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "adminCheck",
      checked: values.adminCheck,
      label: "Hide the admin's tracking and leave data from the team head and leave approver view",
      id: "Enable-admin-check"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowMemberToAccessScreenCapture",
      checked: values.allowMemberToAccessScreenCapture,
      disabled: values.screenCapture === true ? false : true,
      label: "Allow the employee to see their screen capture",
      id: "Allow-the-employee-to-see-their-screen-capture",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowMemberToDeleteScreenCapture",
      checked: values.allowMemberToDeleteScreenCapture,
      disabled: values.screenCapture === true && values.allowMemberToAccessScreenCapture === true ? false : true,
      label: "Allow the employee to delete their screen capture",
      id: "Allow-employee-to-delete-their-screen-capture",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowHeadToDeleteTeamMemberScreenCapture",
      checked: values.allowHeadToDeleteTeamMemberScreenCapture,
      disabled: values.screenCapture === true ? false : true,
      label: "Allow heads to delete & export their team member's screenshot",
      id: "Allow-heads-to-delete-their-team-members-screenshot",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    }))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowMemberToAccessTimesheet",
      checked: values.allowMemberToAccessTimesheet
      // disabled={planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b"}
      ,
      label: "Allow the employee to see their timesheet",
      id: "Allow-the-employee-to-see-their-timesheet",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, !values.screenCapture || !values.generateTimelapseVideo ?
    /*#__PURE__*/
    // There is no time-lapse video to show unless screen capture and
    // generation are both on, so name what is missing instead of
    // leaving a checkbox that cannot be ticked unexplained.
    React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please enable ".concat(!values.screenCapture ? '"Enable screen capture"' : '', " ").concat(!values.screenCapture && !values.generateTimelapseVideo ? ' and ' : '', " ").concat(!values.generateTimelapseVideo ? '"Allow to generate timelapse video"' : '', " to let the\n                          employee see their time-lapse video"))
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      checked: values.allowMemberToAccessTimelapseVideo,
      disabled: true,
      label: "Allow the employee to see their time-lapse video",
      id: "Allow-the-employee-to-see-their-time-lapse-video*",
      className: "track-settingts-checkbox"
    }))) : /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowMemberToAccessTimelapseVideo",
      checked: values.allowMemberToAccessTimelapseVideo,
      label: "Allow the employee to see their time-lapse video",
      id: "Allow-the-employee-to-see-their-time-lapse-video*",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowHeadsToReviewApps",
      checked: values.allowHeadsToReviewApps,
      label: "Allow heads to review apps & sites",
      id: "Allow-heads-to-review-apps",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowTheEmployeeToAccessWebsite",
      checked: values.allowTheEmployeeToAccessWebsite,
      label: "Allow the employee to access website",
      id: "Allow-the-employee-to-access-website",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "hideTheAdminDataFromAllPages",
      checked: values.hideTheAdminDataFromAllPages,
      label: "Hide the admin's data from all pages",
      id: "Hide-the-admin-data-from-all-pages"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "hideTheTeamHeadDataFromAllPages",
      checked: values.hideTheTeamHeadDataFromAllPages,
      label: "Hide the team head's data from all pages",
      id: "Hide-the-team-head-data-from-all-pages"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "hideEditTrackSettingsFromTeamHeads",
      checked: values.hideEditTrackSettingsFromTeamHeads,
      label: "Hide edit track settings from team heads",
      id: "Hide-edit-track-settings-from-team-head"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Holiday Settings", " ", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium")), (planId !== "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || preminumPlanSetting) && (planId !== "93844da8-71e8-4e94-b6ac-aaff5d8a858c" || preminumPlanSetting) ? /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "holidayMailCheck",
      checked: values.holidayMailCheck,
      label: "Auto-send holiday notifications to employees",
      id: "holiday-mail-users"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade to premium plan to enable holiday settings")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "holidayMailCheck",
      disabled: planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || planId === "93844da8-71e8-4e94-b6ac-aaff5d8a858c",
      label: "Auto-send holiday notifications to employees",
      id: "holiday-mail-users"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "API Settings ", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium")), (planId !== "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || preminumPlanSetting) && (planId !== "93844da8-71e8-4e94-b6ac-aaff5d8a858c" || preminumPlanSetting) ? /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "enableApiAccess",
      checked: values.enableApiAccess,
      label: "Enable API Access",
      id: "enable-api-access"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade to premium plan to enable api access")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "enableApiAccess",
      disabled: planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || planId === "93844da8-71e8-4e94-b6ac-aaff5d8a858c",
      label: "Enable API Access",
      id: "enable-api-access"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Real Time Alert Settings", " ", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium")), (planId !== "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || preminumPlanSetting) && (planId !== "93844da8-71e8-4e94-b6ac-aaff5d8a858c" || preminumPlanSetting) ? /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "enableRealTimeAlert",
      checked: values.enableRealTimeAlert,
      label: "Enable Real Time Alert",
      id: "enable-real-time-alert"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade to premium plan to enable real time alert")
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "enableRealTimeAlert",
      disabled: planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || planId === "93844da8-71e8-4e94-b6ac-aaff5d8a858c",
      label: "Enable Real Time Alert",
      id: "enable-real-time-alert"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    })))), orgSettings.indexOf("projects") > -1 ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Projects And Offscreen Tasks"), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "projectManagementFeature",
      checked: values.projectManagementFeature,
      label: "Enable project management",
      id: "Enable-project-management",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Allow admin and heads to add a project",
      name: "addProjectDetails",
      value: "allowAdminAndHeadsToAddAProject",
      checked: values.allowAdminAndHeadsToAddAProject,
      disabled: values.projectManagementFeature === true ? false : true,
      id: "Allow-admin-and-heads-to-add-a-project",
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Allow everyone to add projects",
      name: "addProjectDetails",
      value: "allowEveryoneToAddProject",
      checked: values.allowEveryoneToAddProject,
      disabled: values.projectManagementFeature === true ? false : true,
      id: "Allow-everyone-to-add-projects",
      className: "track-settingts-checkbox"
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Allow admin and heads add a task in the project",
      name: "addTaskDetails",
      value: "allowAdminHeadToAddTaskInProject",
      checked: values.addTaskDetails === "allowAdminHeadToAddTaskInProject",
      disabled: values.projectManagementFeature === true ? false : true,
      id: "Allow-admin-and-heads-add-a-task-in-the-project",
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Allow everyone to add a task in the project",
      name: "addTaskDetails",
      value: "allowEveryoneToAddTaskInProject",
      checked: values.addTaskDetails === "allowEveryoneToAddTaskInProject",
      disabled: values.projectManagementFeature === true ? false : true,
      id: "Allow-everyone-to-add-a-task-in-the-project",
      className: "track-settingts-checkbox"
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "offlineTask",
      checked: values.offlineTask,
      disabled: values.projectManagementFeature === true ? false : true,
      label: "Enable offscreen tasks",
      id: "Allow-offline-tasks",
      className: "track-settingts-checkbox"
      //isInvalid={emailError != null}
    }))) : null), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      className: "timesheet-setting-sub-button-div"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "timesheet-setting-sub-button",
      type: "submit",
      disabled: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? addWorkDaySettingsLoading || isSubmitting : false
    }, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" && (addWorkDaySettingsLoading || isSubmitting) ? "Loading..." : "Save Track Settings"))));
  }), /*#__PURE__*/React.createElement(Alert, {
    variant: "secondary",
    className: "track-settings-note-text-alert"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement(FaInfoCircle, {
    className: "mr-2 mt-1 track-settings-note-text-alert-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-muted track-settings-note-text-alert-div track-settings-note-text-alert-div-1"
  }, "Please note that changes to desktop app settings\u2014such as idle time detection and screenshot capture\u2014may take up to 2 hours to reflect across all systems.")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement(FaInfoCircle, {
    className: "mr-2 mt-1 track-settings-note-text-alert-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-muted track-settings-note-text-alert-div"
  }, "Changing your timezone may affect your historical data, including timesheet entries, reports, and activity logs. Proceed only if you\u2019re sure you want to update your timezone."))), /*#__PURE__*/React.createElement(UserSettingsUpdatedModal, {
    show: showUserSettingsUpdateModal,
    onClose: function onClose() {
      return setUserShowSettingsUpdateModal(false);
    },
    loading: addWorkDaySettingsLoading,
    onConfirm: ( /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(applyTo) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return handleSubmit(pendingFormValues, applyTo);
            case 2:
              setUserShowSettingsUpdateModal(false);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3) {
        return _ref12.apply(this, arguments);
      };
    }())
  }));
};
var UserSettingsUpdatedModal = function UserSettingsUpdatedModal(_ref13) {
  var show = _ref13.show,
    onClose = _ref13.onClose,
    onConfirm = _ref13.onConfirm,
    loading = _ref13.loading;
  var _React$useState29 = React.useState("organisationOnly"),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    applyTo = _React$useState30[0],
    setApplyTo = _React$useState30[1];
  var _React$useState31 = React.useState(null),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    clickedBtn = _React$useState32[0],
    setClickedBtn = _React$useState32[1];
  if (!show) {
    return null;
  }
  var changes = _typeof(show) === "object" ? show : {};
  var EXCLUDE_KEYS = new Set(["organisationId", "planType", "timezone"]);
  var SETTING_CONFIG = {
    // Work Day Settings
    workingDays: {
      label: "Choose work days",
      Icon: FaDesktop
    },
    // Work Time Settings
    workingHoursPerDay: {
      label: "Expected work hours",
      Icon: FaClock
    },
    productiveHours: {
      label: "Expected productive apps usage time",
      Icon: FaClock
    },
    expectedActiveTime: {
      label: "Expected active time (Excluding idle time from total work time)",
      Icon: FaClock
    },
    organisationTimezone: {
      label: "Organisation timezone",
      Icon: FaDesktop
    },
    expectedClockInTime: {
      label: "Expected Clock-in",
      Icon: FaClock
    },
    enablePersonWiseTimezone: {
      label: "Enable person wise timezone",
      Icon: FaDesktop
    },
    // Stealth Mode
    stealthMode: {
      label: "Enable stealth mode to everyone",
      Icon: FaDesktop
    },
    // Project Management
    projectManagementFeature: {
      label: "Enable project management",
      Icon: FaDesktop
    },
    enableProjectManagementDesktopUI: {
      label: "Enable project management desktop UI",
      Icon: FaDesktop
    },
    allowEmployeesToManageTheirTasks: {
      label: "Allow team members to add, edit and delete their tasks",
      Icon: FaDesktop
    },
    allowEmployeesToMarkTheirTasksAsCompleted: {
      label: "Allow team members to mark their tasks as completed & hold",
      Icon: FaDesktop
    },
    allowEmployeesToEditTaskTimes: {
      label: "Allow team members to edit task times",
      Icon: FaDesktop
    },
    allowEmailNotificationWhenTaskStatusChange: {
      label: "Send email notifications when task status changes",
      Icon: FaBell
    },
    automaticTaskTimer: {
      label: "Auto start and end task using current time",
      Icon: FaClock
    },
    restrictNewTaskWhenPending: {
      label: "Restrict new tasks when a previous task is pending",
      Icon: FaDesktop
    },
    organisationCurrencie: {
      label: "Project currency",
      Icon: FaDesktop
    },
    addProjectDetails: {
      label: "Who can add a project",
      Icon: FaDesktop
    },
    addTaskDetails: {
      label: "Who can add a task in the project",
      Icon: FaDesktop
    },
    offlineTask: {
      label: "Enable offscreen tasks",
      Icon: FaDesktop
    },
    // Leave Management
    leaveManagementFeature: {
      label: "Enable leave management",
      Icon: FaDesktop
    },
    // Manual Time
    manualTimeFeature: {
      label: "Enable manual time to everyone",
      Icon: FaClock
    },
    manualTimeMailCheck: {
      label: "Send manual time notifications to admins",
      Icon: FaBell
    },
    // Untracked Hours
    excludeUntrackedHours: {
      label: "Exclude hours with internet interruptions in total work hours",
      Icon: FaClock
    },
    // Payroll
    enableSalaryCalculator: {
      label: "Enable Payroll Calculator",
      Icon: FaDesktop
    },
    payrollCurrency: {
      label: "Payroll currency",
      Icon: FaDesktop
    },
    payrollCycle: {
      label: "Payroll cycle",
      Icon: FaRegCalendarAlt
    },
    payrollWeekStartsOn: {
      label: "Week starts on",
      Icon: FaRegCalendarAlt
    },
    // Keyboard & Mouse
    keyStrokeCounter: {
      label: "Enable Track Keypress Count on Windows",
      Icon: FaDesktop
    },
    mouseTracker: {
      label: "Enable Mouse Activity Tracking on Windows",
      Icon: FaDesktop
    },
    // Email Report
    reportSettings: {
      label: "Email report settings",
      Icon: FaBell
    },
    // Screenshot Settings
    screenCapture: {
      label: "Enable screen capture",
      Icon: FaCamera
    },
    blurScreenCapture: {
      label: "Blur screen capture",
      Icon: FaCamera
    },
    screenCaptureInterval: {
      label: "Screen capture interval",
      Icon: FaCamera
    },
    generateTimelapseVideo: {
      label: "Allow to generate timelapse video",
      Icon: FaCamera
    },
    // Idle Time Settings
    idleMinutesThreshold: {
      label: "Start to consider as idle if the employee is inactive for",
      Icon: FaClock
    },
    idleAlertMinutes: {
      label: "Automatically send idle alert and pause timer if idle for more than",
      Icon: FaClock
    },
    idleAlertOverride: {
      label: "Show idle alerts even for apps excluded from idle detection",
      Icon: FaBell
    },
    idleAlertBreak: {
      label: "Idle Alert Action",
      Icon: FaBell
    },
    idleTimeStrictnessLevel: {
      label: "Minimum activity per minute",
      Icon: FaClock
    },
    // Permissions
    adminCheck: {
      label: "Hide the admin's tracking data from the team head view",
      Icon: FaDesktop
    },
    allowMemberToAccessScreenCapture: {
      label: "Allow the employee to see their screen capture",
      Icon: FaCamera
    },
    allowMemberToDeleteScreenCapture: {
      label: "Allow the employee to delete their screen capture",
      Icon: FaCamera
    },
    allowHeadToDeleteTeamMemberScreenCapture: {
      label: "Allow heads to delete & export their team member's screenshot",
      Icon: FaCamera
    },
    allowMemberToAccessTimesheet: {
      label: "Allow the employee to see their timesheet",
      Icon: FaDesktop
    },
    allowMemberToAccessTimelapseVideo: {
      label: "Allow the employee to see their time-lapse video",
      Icon: FaCamera
    },
    allowHeadsToReviewApps: {
      label: "Allow heads to review apps & sites",
      Icon: FaDesktop
    },
    allowTheEmployeeToAccessWebsite: {
      label: "Allow the employee to access website",
      Icon: FaDesktop
    },
    hideTheAdminDataFromAllPages: {
      label: "Hide the admin's data from all pages",
      Icon: FaDesktop
    },
    hideTheTeamHeadDataFromAllPages: {
      label: "Hide the team head's data from all pages",
      Icon: FaDesktop
    },
    hideEditTrackSettingsFromTeamHeads: {
      label: "Hide edit track settings from team heads",
      Icon: FaDesktop
    },
    // Holiday Settings
    holidayMailCheck: {
      label: "Auto-send holiday notifications to employees",
      Icon: FaBell
    },
    // API Settings
    enableApiAccess: {
      label: "Enable API Access",
      Icon: FaDesktop
    },
    // Real Time Alert
    enableRealTimeAlert: {
      label: "Enable Real Time Alert",
      Icon: FaBell
    },
    // Auto Clock-in
    autoClockIn: {
      label: "Enable the auto clock-in feature to everyone",
      Icon: FaClock
    }
  };
  var formatValue = function formatValue(key, value) {
    var _PayrollCycleList$fin, _WeekStartDaysList$fi;
    // idleAlertBreak is a radio choice, not an on/off toggle
    if (key === "idleAlertBreak") {
      return value === "true" || value === true ? "Show popup and pause work timer" : "Show popup only";
    }
    if (value === "true" || value === true) return "Enabled";
    if (value === "false" || value === false) return "Disabled";
    if (key === "payrollCycle") return ((_PayrollCycleList$fin = PayrollCycleList.find(function (c) {
      return c.value === value;
    })) === null || _PayrollCycleList$fin === void 0 ? void 0 : _PayrollCycleList$fin.label) || value;
    if (key === "payrollWeekStartsOn") return ((_WeekStartDaysList$fi = WeekStartDaysList.find(function (d) {
      return d.value === value;
    })) === null || _WeekStartDaysList$fi === void 0 ? void 0 : _WeekStartDaysList$fi.label) || value;
    if (key === "screenCaptureInterval") return "".concat(value, " minutes");
    // idleAlertMinutes "0" means the idle alert is switched off
    if (key === "idleAlertMinutes" && Number(value) === 0) return "Disabled";
    if (key === "idleAlertMinutes" || key === "idleMinutesThreshold") return "".concat(value, " minutes");
    // idleTimeStrictnessLevel null / "0" means minimum activity is switched off
    if (key === "idleTimeStrictnessLevel") return Number(value) > 0 ? "".concat(value, " sec") : "Disabled";
    var numVal = Number(value);
    if ((key === "workingHoursPerDay" || key === "productiveHours") && !isNaN(numVal)) {
      var hours = Math.floor(numVal / 60);
      var mins = numVal % 60;
      return mins > 0 ? "".concat(hours, "h ").concat(mins, "m") : "".concat(hours, " hours");
    }
    return value;
  };
  var displayedChanges = Object.entries(changes).filter(function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 1),
      key = _ref15[0];
    return !EXCLUDE_KEYS.has(key);
  }).map(function (_ref16) {
    var _ref17 = _slicedToArray(_ref16, 2),
      key = _ref17[0],
      value = _ref17[1];
    var config = SETTING_CONFIG[key];
    return {
      key: key,
      label: (config === null || config === void 0 ? void 0 : config.label) || key.replace(/([A-Z])/g, " $1").trim(),
      Icon: (config === null || config === void 0 ? void 0 : config.Icon) || FaInfoCircle,
      displayValue: formatValue(key, value)
    };
  });
  return /*#__PURE__*/React.createElement(Modal, {
    show: !!show,
    onHide: onClose,
    centered: true,
    size: "lg",
    backdrop: "true",
    keyboard: false,
    className: "track-setting-settings-update-modal track-setting-apply-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "border-bottom-0 pb-2 track-setting-apply-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    as: "h5",
    className: "font-weight-bold"
  }, "How would you like to apply these changes?")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "pt-0 pb-4 track-setting-apply-modal-body"
  }, /*#__PURE__*/React.createElement("p", {
    className: "track-setting-apply-modal-subtitle"
  }, "You updated the organization tracking settings. Choose where these changes should be applied."), /*#__PURE__*/React.createElement("hr", {
    className: "my-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mb-4 mt-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-weight-bold mb-2 track-setting-apply-modal-body-changes-list"
  }, "Changes Made"), /*#__PURE__*/React.createElement("div", {
    className: "track-setting-apply-modal-changes-list"
  }, displayedChanges.length > 0 ? displayedChanges.map(function (_ref18) {
    var key = _ref18.key,
      label = _ref18.label,
      Icon = _ref18.Icon,
      displayValue = _ref18.displayValue;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: "track-setting-apply-modal-changes-item"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "track-setting-apply-modal-changes-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "track-setting-apply-modal-changes-item-span"
    }, label, ": ", /*#__PURE__*/React.createElement("strong", null, displayValue)));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted p-3",
    style: {
      fontSize: "0.9rem"
    }
  }, "No changes were made to settings."))), /*#__PURE__*/React.createElement("hr", {
    className: "my-3"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "track-setting-apply-modal-option".concat(applyTo === "organisationOnly" ? " selected" : ""),
    onClick: function onClick() {
      return setApplyTo("organisationOnly");
    }
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "radio",
    id: "applyOrgOnly",
    checked: applyTo === "organisationOnly",
    onChange: function onChange() {
      return setApplyTo("organisationOnly");
    },
    className: "track-setting-apply-modal-option-radio",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "track-setting-apply-modal-option-label"
  }, "Organization Only (Recommended)"), /*#__PURE__*/React.createElement("p", {
    className: "track-setting-apply-modal-option-desc"
  }, "Keep employee-level custom settings unchanged. These new settings will be saved only at the organization level and will apply only to employees who use the default organization settings."))), /*#__PURE__*/React.createElement("div", {
    className: "track-setting-apply-modal-option".concat(applyTo === "everyone" ? " selected" : "", " track-setting-apply-modal-option-everyone"),
    onClick: function onClick() {
      return setApplyTo("everyone");
    }
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "radio",
    id: "applyEveryone",
    checked: applyTo === "everyone",
    onChange: function onChange() {
      return setApplyTo("everyone");
    },
    className: "track-setting-apply-modal-option-radio",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-100"
  }, /*#__PURE__*/React.createElement("span", {
    className: "track-setting-apply-modal-option-label"
  }, "Apply to All Employees (This will override all existing individual employee settings)"), /*#__PURE__*/React.createElement("p", {
    className: "track-setting-apply-modal-option-desc"
  }, "Apply these changes to the organization and all employees, replacing any employee-level settings."))))), /*#__PURE__*/React.createElement(Modal.Footer, {
    className: "border-top track-setting-apply-modal-footer"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "border px-4",
    disabled: loading,
    onClick: function onClick() {
      setClickedBtn("cancel");
      onClose();
    }
  }, loading && clickedBtn === "cancel" ? /*#__PURE__*/React.createElement("span", {
    className: "spinner-border spinner-border-sm mr-2",
    role: "status",
    "aria-hidden": "true"
  }) : null, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "px-4",
    disabled: loading,
    onClick: function onClick() {
      setClickedBtn("continue");
      onConfirm(applyTo);
    }
  }, loading && clickedBtn === "continue" ? /*#__PURE__*/React.createElement("span", {
    className: "spinner-border spinner-border-sm mr-2",
    role: "status",
    "aria-hidden": "true"
  }) : null, "Save Settings Changes")));
};

// const SettingsUpdatedModal = ({ show, onClose }) => {
//   if (!show) {
//     return null;
//   }

//   const getInitialValue = () => localStorage.getItem("showSettingsUpdatedWarningAgain") === "true";

//   const [dontShowAgain, setDontShowAgain] = React.useState(getInitialValue);

//   React.useEffect(() => {
//     if (show) {
//       // reset every time modal opens
//       setDontShowAgain(getInitialValue());
//     }
//   }, [show]);

//   const handleOk = () => {
//     localStorage?.setItem?.("showSettingsUpdatedWarningAgain", dontShowAgain);
//     onClose();
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={onClose}
//       centered
//       backdrop="true"
//       keyboard={false}
//       className="track-setting-settings-update-modal"
//     >
//       <Modal.Body className="track-setting-settings-update-modal-body">
//         <h4 className="font-weight-bold mb-3 track-setting-settings-update-modal-body-header">
//           Settings Updated Successfully
//         </h4>

//         <p className="text-muted mb-4 track-setting-settings-update-modal-body-msg">
//           Settings related to the desktop app, including <strong>Screenshot Interval</strong> and{" "}
//           <strong>Idle Detection</strong>, may take up to <strong>2 hours</strong> to reflect on your team members’
//           computers. However, reopening the desktop app will apply the new settings immediately.
//         </p>

//         <Form.Group controlId="dontShowAgain" className="track-setting-settings-update-modal-body-form">
//           <Form.Check
//             type="checkbox"
//             label="Don't show this warning again in this browser"
//             checked={dontShowAgain}
//             onChange={(e) => {
//               setDontShowAgain(e.target.checked);
//             }}
//             className="text-muted track-setting-settings-update-modal-body-form-check"
//           />
//         </Form.Group>

//         <div className="d-flex justify-content-end mt-4 track-setting-settings-update-modal-body-form-button-wrapper">
//           <Button variant="primary" onClick={handleOk} className="track-setting-settings-update-modal-body-form-button">
//             OK
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

export default TimesheetSettings;